import secureLocalStorage from 'react-secure-storage';
import { handleExecutionLog } from '../../../../components/ExecutionLogHandler';
import { getPromotionsSearch } from '../../Promotion/AuthAction';
import {
  CUSTOMER_MASTER_SUCCESS,
  CUSTOMER_MASTER_XREF_SUCCESS,
  CUSTOMER_MASTER_XREF_BY_ID_SUCCESS,
  CUSTOMER_MASTER_XREF_FIELDS_SUCCESS,
  MATERIAL_MASTER_SUCCESS,
  SUPPLIER_MASTER_SUCCESS,
  IMA_CONFIG_XREF_CUSTOMER_MASTER_SUCCESS,
  IMA_CONFIG_CUSTOMER_MASTER_SUCCESS,
  IMA_CONFIG_XREF_MATERIAL_MASTER_SUCCESS,
  MEMBERSHIP_SUCCESS,
  MEMBERSHIP_ROSTER_DETAILBYID_SUCCESS,
  UPLOAD_MEMBERSHIP_CUSTOMER_UPLOAD_SUCCESS,
  MASTER_REPORT_SUCCESS,
  MEMBERSHIP_DETAIL_SUCCESS,
  MEMBERSHIP_FORMAT_SUCCESS,
  MEMBERSHIP_FORMAT_BY_ID_SUCCESS,
  MEMBERSHIP_FORMAT_FIELDS_SUCCESS,
  MEMBERSHIP_UPLOAD_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_FORMAT_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_FORMAT_BY_ID_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_FORMAT_FIELDS_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_UPLOAD_SUCCESS,
  BOM_SUCCESS,
  BOM_DETAIL_SUCCESS,
  BOM_FORMAT_SUCCESS,
  BOM_FORMAT_BY_ID_SUCCESS,
  BOM_FORMAT_FIELDS_SUCCESS,
  BOM_UPLOAD_SUCCESS,
  EMPLOYEE_MASTER_SUCCESS,
  EMPLOYEE_MASTER_VIEW_DETAIL_SUCCESS,
  INTEGRATION_SETUP_SUCCESS,
  INTEGRATION_CONNECTION_DATA_SUCCESS,
  INTEGRATION_CONNECTION_DATA_NO_STATUS_SUCCESS,
  SINGLE_INTEGRATION_CONNECTION_DATA_SUCCESS,
  INTEGRATION_PROFILE_DATA_SUCCESS,
  INTEGRATION_STAGING_DATA_SUCCESS,
  TRACK_ACTIVITY_SUCCESS,
  FILTER_LIST_SUCCESS,
  FILTER_LIST_FAIL,
  FILTER_BY_ID_LIST_SUCCESS,
  INTEGRATION_BY_ID_SUCCESS,
  TERRITORY_SUCCESS,
  FETCH_START,
  FETCH_END,
  FETCH_START1,
  FETCH_END1,
  APPROVAL_DESIGNER_GET_SUCCESS,
  APPROVAL_DESIGNER_DETAIL_SUCCESS,
  CONTRACT_DEFAULT_DESIGNER_SUCCESS,
  CONTRACT_DEFAULT_DETAIL_SUCCESS,
  PAYMENT_DESIGNER_GET_SUCCESS,
  ACCRUAL_DESIGNER_GET_SUCCESS,
  ACCRUAL_DESIGNER_SINGLE_SUCCESS,
  PAYMENT_DESIGNER_SINGLE_SUCCESS,
  SALES_BASIS_ALL,
  SALES_BASIS_SINGLE,
  BATCH_JOB_ALL,
  BATCH_JOB_DETAIL,
  PRICING_BATCH_JOB_ALL,
  PRICING_BATCH_JOB_DETAIL,
  EXCEPTION_MANAGEMENT_ALL,
  EXCEPTION_MANAGEMENT_SINGLE,
  EXCEPTION_MANAGEMENT_VIEW_DETAIL_SUCCESS,
  EXCEPTION_MANAGEMENT_TIER_EVALS,
  WORKFLOW_ANCHORS,
  BATCH_JOB_STATUS,
  BATCH_JOB_REPORT,
  BATCH_JOB_REPORT_EXECUTION_LOG,
  BATCH_JOB_CONFIGURATION,
  BATCH_JOB_SCHEDULE,
  BATCH_JOB_STATUS_SECOND_PAGE,
  BATCH_JOB_STATUS_SINGLE_DATA,
  PRODUCT_GROUP_SUCCESS,
  PRODUCT_GROUP_SINGLE_SUCCESS,
  PRODUCT_GROUP_FORMAT_SUCCESS,
  PRODUCT_GROUP_FORMAT_FIELDS_SUCCESS,
  PRODUCT_GROUP_FORMAT_BY_ID_SUCCESS,
  PRODUCT_GROUP_UPLOAD_SUCCESS,
  GENERAL_UOM,
  CONVERSION_SUCCESS,
  TERRITORY_LIST_SUCCESS,
  TERRITORY_SINGLE_SUCCESS,
  INTEGRATION_MAPPING_SUCCESS,
  INTEGRATION_MAPPING_BY_ID,
  INTEGRATION_MAPPING_FIELDS,
  INTEGRATION_QUALIFIERS_SUCCESS,
  INTEGRATION_CONFIGURATION_SUCCESS,
  NEW_INTEGRATION_MAPPING_SUCCESS,
  NEW_INTEGRATION_MAPPINGS_DATA_BY_ID,
  INTEGRATION_QUALIFIERS_FUNCTIONALITY_SUCCESS,
  INTEGRATION_QUALIFIERS_TABLE_NAME_SUCCESS,
  INTEGRATION_QUALIFIERS_DATA_BY_ID,
  INTEGRATION_LIST_DATA_SUCCESS,
  INTEGRATION_LIST_DATA_BY_ID,
  MAPPING_CREATE_SUCCESS,
  INTEGRATION_LOAD_FREQUENCY,
  INTEGRATION_ACTIVITY,
  INTEGRATION_DATA_SOURCE,
  IM_HISTORY_SUCCESS,
  BATCH_INTEGRATION_JOB_ALL,
  BATCH_INTEGRATION_JOB_STATUS,
  FECTCH_INTEGRATION_SETUP_SUCCESS,
  MEMBERSHIP_HIERARCHY_SUCCESS,
  SALES_COMMISSION_CONFIG_SUCCESS,
  SC_TRACK_AND_TRACE_DATA_SUCCESS,
  SC_BASE_CONFIG_DATA_SUCCESS,
  CHANGE_LOG_DATA_SUCCESS,
  SC_TRACK_AND_TRACE_LOG_DATA_SUCCESS,
  SC_TRACK_AND_TRACE_LOG_DATA_CLEAR,
  PRICING_LOGS_BY_ID_SUCCESS,
  SALES_COMMISSION_CONFIG_DETAILBYID_SUCCESS,
  MEMBERSHIP_CONTRACT_XREF_SUCCESS,
  MEMBERSHIP_CONTRACT_XREF_BY_ID,
  MEMBERSHIP_CONTRACT_GROUP_SUCCESS,
  MEMBERSHIP_CONTRACT_GROUP_BY_ID,
  SALES_BUNDLE_SUCCESS,
  GPO_ADDRESS_SEARCH_SUCCESS,
  TIER_ACTI_ADDRESS_SEARCH_SUCCESS,
  MASS_MEMBERSHIP_UPDATE,
  MASS_MEBERSHIP_UPDATE_ACTION,
  WORK_FLOW_ASSIGNMENTS_SUCCESS,
  WORK_FLOW_ASSIGNMENTS_DETAIL_SUCCESS,
  UPLOAD_INTEGRATION_FILE,
  DEFAULT_DESIGNER_CONFIG_SUCCESS,
  GET_ACQUIRE_DATA_SUCCESS,
  SEARCH_SUPPLIER_NUMBER_SUCCESS
} from './ActionTypes';
import axios from '../../../../axios.conf';
import { toast } from 'react-toastify';
import { toast as appToast } from '../../../../components/ToastManager';
import moment from 'moment-timezone';
import { ServerError } from '../../../../library/constants';
import { history } from '../../../../components/Helpers';
import { updateFilterValues } from '../../Simulations/OperationalReports/AuthAction';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
export const fetchStart1 = () => {
  return {
    type: FETCH_START1,
  };
};

export const fetchEnd1 = () => {
  return {
    type: FETCH_END1,
  };
};
//customer master user
export const reConcile = (data, claimNumber, reconcile) => {
  return (dispatch) => {
    reConcileAPI(data)
      .then((response) => {
        toast.success('Successfully reconciled');
        // if (reconcile === 'reconcile') {
        //     dispatch(getIncomingClaims());
        // } else {
        //     dispatch(editIncomingClaim(claimNumber));
        // }
      })
      .catch((error) => {
        //toast.error('Error in updating data. Please try again.')
      });
  };
};

const reConcileAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('update-claims', data, { headers: headers });
  return result;
};

//get list customer master
export const getCustomerMasterData = (pagination, limit, keyword, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCustomerMasterDataApi(pagination, limit, keyword, data)
      .then((response) => {
        if (keyword === 'search') {
          dispatch(fetchEnd());
          dispatch(getCustomerMastrDataSuccess(response.data.response));
          history.push('/customer-master');
        } else {
          dispatch(fetchEnd());
          dispatch(getCustomerMastrDataSuccess(response.data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCustomerMasterDataApi = (pagination, limit, keyword, data) => {
  if (keyword === 'search') {
    for (var propName in data) {
      if (
        data[propName] === '' ||
        data[propName] === null ||
        data[propName] === undefined ||
        data[propName].length === 0 ||
        data[propName] ===
        '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
        data[propName] === '1970-01-01T00:00:00.000Z' ||
        data[propName] === ','
      ) {
        delete data[propName];
      }
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  // if (keyword === 'search') {
  //   result = axios.get("customer-data?page=" + pagination + "&&limit=" + 0, { params: data }, { headers: headers });
  // }
  if (keyword === 'search') {
    result = axios.post(
      'master-data-search?page=' +
      pagination +
      '&&limit=' +
      0 +
      '&&table_name=customer_master',
      data,
      { headers: headers },
    );
  } else {
    if (pagination) {
      result = axios.get(
        'customer-data?page=' + pagination + '&&limit=' + limit,
        {
          headers: headers,
        },
      );
    } else {
      result = axios.get('customer-data?limit=' + limit, { headers: headers });
    }
  }
  return result;
};

export const getCustomerMastrDataSuccess = (data) => {
  return {
    type: CUSTOMER_MASTER_SUCCESS,
    data,
  };
};

//delete customer master
export const deleteCustomerMasterData = (id, page) => {
  return (dispatch) => {
    deleteCustomerMasterDataAPI(id, page)
      .then((response) => {
        toast.success(response.data.response);
        if (page === 'CustomerXMaster') dispatch(getCustomerMasterXRefData());
        if (page === 'MaterialMaster') {
          dispatch(
            getMaterialMasterData(
              1,
              0,
              'search',
              JSON.parse(sessionStorage.getItem('search-data')),
            ),
          );
          dispatch(
            getMaterialMasterData(
              1,
              0,
              'search',
              JSON.parse(sessionStorage.getItem('search-data')),
            ),
          );
          history.push('/material-master');
        }
        if (page === 'SupplierMaster') {
          dispatch(
            getSupplierMasterData(
              1,
              0,
              'search',
              JSON.parse(sessionStorage.getItem('search-data')),
            ),
          );
          history.push('/supplier-master');
        }
        if (page === 'MaterialMasterPromo') {
          dispatch(
            getPromotionsSearch(
              1,
              0,
              'search',
              JSON.parse(sessionStorage.getItem('search-data')),
              'promotion_material_master',
            ),
          );
        }
        if (page === 'Membership') dispatch(getMembershipData(1, 10));
        if (page === 'EmployeeMaster') dispatch(getEmployeeData(1, 10));
        if (page === 'CustomerMaster') {
          dispatch(
            getCustomerMasterData(
              1,
              0,
              'search',
              JSON.parse(sessionStorage.getItem('search-data')),
            ),
          );
          dispatch(
            getCustomerMasterData(
              1,
              0,
              'search',
              JSON.parse(sessionStorage.getItem('search-data')),
            ),
          );
          history.push('/customer-master');
        }
      })
      .catch((error) => {
        //toast.error('Something went wrong.');
      });
  };
};

const deleteCustomerMasterDataAPI = (id, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'CustomerXMaster')
    result = axios.delete('xref-customer-data/' + id, { headers: headers });
  else if (page === 'MaterialMaster' || page === 'MaterialMasterPromo') {
    result = axios.delete('material-master/' + id, { headers: headers });
  } else if (page === 'SupplierMaster')
    result = axios.delete('supplier-master/' + id, { headers: headers });
  else if (page === 'Membership')
    result = axios.delete('membership/' + id, { headers: headers });
  else if (page === 'SalesBundle')
    result = axios.delete('bom/' + id, { headers: headers });
  else if (page === 'EmployeeMaster')
    result = axios.delete('employee/' + id, { headers: headers });
  else result = axios.delete('customer-data/' + id, { headers: headers });
  return result;
};

//edit customer data
//customer master x ref

//get list customer master xref
export const getCustomerMasterXRefData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCustomerMasterXRefDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCustomerMastrXrefDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const getCustomerMasterXRefDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('xref-customer-data?page=1&&limit=0', {
    headers: headers,
  });
  return result;
};

export const getCustomerMastrXrefDataSuccess = (data) => {
  return {
    type: CUSTOMER_MASTER_XREF_SUCCESS,
    data,
  };
};

// get customer master xref format data by id
export const getCustomerMastrXrefFormatDataById = (id, page) => {
  return (dispatch) => {
    getCustomerMastrXrefFormatDataByIdApi(id, page)
      .then((response) => {
        dispatch(
          getCustomerMastrXrefFormatDataByIdSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getCustomerMastrXrefFormatDataByIdApi = (id, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'DirectSalesExternalCalculationFormat') {
    result = axios.get(
      '/upload-format/' +
      id +
      '?app-functionality=DirectSalesExternalCalculationFormat',
      { headers: headers },
    );
  } else if (page === 'DirectSalesFinancialPostingFormat') {
    result = axios.get(
      '/upload-format/' +
      id +
      '?app-functionality=DirectSalesFinancialPostingFormat',
      { headers: headers },
    );
  } else {
    result = axios.get(
      '/upload-format/' + id + '?app-functionality=XrefCustomerDataFormats',
      { headers: headers },
    );
  }
  return result;
};

export const getCustomerMastrXrefFormatDataByIdSuccess = (data) => {
  return {
    type: CUSTOMER_MASTER_XREF_BY_ID_SUCCESS,
    data,
  };
};
// get customer master xref format fields
export const getCustomerMastrXrefFormatFields = (page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCustomerMastrXrefFormatFieldsApi(page)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(
          getCustomerMastrXrefFormatFieldsSuccess(response.data.response),
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getCustomerMastrXrefFormatFieldsApi = (page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'DirectSalesExternalCalculationFormat') {
    result = axios.get(
      'upload-format-fields?app-functionality=DirectSalesExternalCalculationFormat',
      { headers: headers },
    );
  } else if (page === 'DirectSalesFinancialPostingFormat') {
    result = axios.get(
      'upload-format-fields?app-functionality=DirectSalesFinancialPostingFormat',
      { headers: headers },
    );
  } else {
    result = axios.get(
      'upload-format-fields?app-functionality=XrefCustomerDataFormats',
      { headers: headers },
    );
  }
  return result;
};

export const getCustomerMastrXrefFormatFieldsSuccess = (data) => {
  return {
    type: CUSTOMER_MASTER_XREF_FIELDS_SUCCESS,
    data,
  };
};

// update customer master xref
export const updateCustomerMastrXrefFormatData = (id, data, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateCustomerMastrXrefFormatDataApi(id, data, page)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success('Format updated successfully');
          if (page === 'DirectSalesExternalCalculationFormat') {
            history.push('/upload-external-calculation-main');
          } else if (page === 'DirectSalesFinancialPostingFormat') {
            history.push('/upload-external-posting-main');
          }
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const updateCustomerMastrXrefFormatDataApi = (id, data, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'DirectSalesExternalCalculationFormat') {
    result = axios.put(
      '/upload-format/' +
      id +
      '?app-functionality=DirectSalesExternalCalculationFormat',
      data,
      { headers: headers },
    );
  } else if (page === 'DirectSalesFinancialPostingFormat') {
    result = axios.put(
      '/upload-format/' +
      id +
      '?app-functionality=DirectSalesFinancialPostingFormat',
      data,
      { headers: headers },
    );
  } else {
    result = axios.put(
      '/upload-format/' + id + '?app-functionality=XrefCustomerDataFormats',
      data,
      { headers: headers },
    );
  }
  return result;
};
//material master
//get list of material master data
export const getMaterialMasterData = (pagination, limit, keyword, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMaterialMasterDataApi(pagination, limit, keyword, data)
      .then((response) => {
        if (keyword === 'search') {
          dispatch(fetchEnd());
          dispatch(getMaterialMastrDataSuccess(response.data.response));
          history.push({
            pathname: '/material-master',
            state: 'displayAPICALL',
          });
        } else {
          dispatch(fetchEnd());
          dispatch(getMaterialMastrDataSuccess(response.data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getMaterialMasterDataApi = (pagination, limit, keyword, data) => {
  if (keyword === 'search') {
    for (var propName in data) {
      if (
        data[propName] === '' ||
        data[propName] === null ||
        data[propName] === undefined ||
        data[propName].length === 0 ||
        data[propName] ===
        '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
        data[propName] === '1970-01-01T00:00:00.000Z' ||
        data[propName] === ','
      ) {
        delete data[propName];
      }
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (keyword === 'search') {
    result = axios.post(
      'master-data-search?page=' +
      pagination +
      '&&limit=' +
      0 +
      '&&table_name=material_master',
      data,
      { headers: headers },
    );
  } else {
    if (pagination === 'NoLimit') {
      result = axios.get('material-master?limit=0', { headers: headers });
    }
    // else if (keyword) {
    //   result = axios.get("material-master?keyword=" + keyword, {
    //     headers: headers,
    //   });
    // }
    else {
      result = axios.get(
        'material-master?page=' + pagination + '&&limit=' + limit,
        { headers: headers },
      );
    }
  }
  return result;
};

export const getMaterialMastrDataSuccess = (data) => {
  return {
    type: MATERIAL_MASTER_SUCCESS,
    data,
  };
};

//supplier master
//get list of supplier master data
export const getSupplierMasterData = (pagination, limit, keyword, data) => {
  return (dispatch) => {
    getSupplierMasterDataSuccess([])
    dispatch(fetchStart());
    getSupplierMasterDataApi(pagination, limit, keyword, data)
      .then((response) => {
        if (keyword === 'search') {
          dispatch(fetchEnd());
          dispatch(getSupplierMasterDataSuccess(response.data.response));
          history.push('/supplier-master');
        } else {
          dispatch(fetchEnd());
          dispatch(getSupplierMasterDataSuccess(response.data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getSupplierMasterDataApi = (pagination, limit, keyword, data) => {
  if (keyword === 'search') {
    for (var propName in data) {
      if (
        data[propName] === '' ||
        data[propName] === null ||
        data[propName] === undefined ||
        data[propName].length === 0 ||
        data[propName] ===
        '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
        data[propName] === '1970-01-01T00:00:00.000Z' ||
        data[propName] === ','
      ) {
        delete data[propName];
      }
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  // if (keyword) {
  //   result = axios.get("supplier-master?keyword=" + keyword, {
  //     headers: headers,
  //   });
  // }
  if (keyword === 'search') {
    result = axios.post(
      'master-data-search?page=' +
      pagination +
      '&&limit=' +
      0 +
      '&&table_name=supplier_master',
      data,
      { headers: headers },
    );
  } else {
    result = axios.get('supplier-master?page=1' + '&&limit=0', {
      headers: headers,
    });
  }
  return result;
};

export const getSupplierMasterDataSuccess = (data) => {
  return {
    type: SUPPLIER_MASTER_SUCCESS,
    data,
  };
};

// Acquire Lock
export const getAcquireLockDetails = (data, type) => {
  return (dispatch) => {
    getAcquireLockDetailsApi(data, type)
      .then((response) => {
        // toast.success(response.data.response);
        dispatch(getAcquireLocksData(response.data.response));
      })
      .catch((error) => {
        if (error.response.status == '409') {
          // toast.error(error.response.data.response);
          if (type == 'contract_data') {
            // sessionStorage.removeItem('functionality-name');
            dispatch(getAcquireLocksData(error.response.data));
            // history.push('/contract-setup/view-contract/' + data.id);
          } else {
            toast.error(error.response.data.response);
            history.push('/supplier-master/view-supplier/' + data.id);
          }
        } else if (error.response.status == '501') {
        } else {
          toast.error(error.response.data.response);
        }
      });
  };
};
const getAcquireLockDetailsApi = (data, type) => {
  const config = {
    headers: {
      Authorization: secureLocalStorage.getItem('aTk'),
    },
    params: data,
  };
  var result;
  result = axios.get('acquire-lock', config);
  return result;
};
export const getAcquireLocksData = (data) => {
  return {
    type: GET_ACQUIRE_DATA_SUCCESS,
    data,
  };
};

// Release Lock
export const getReleaseLockDetails = (data) => {
  return (dispatch) => {
    getReleaseLockDetailsApi(data)
      .then((response) => {
        // toast.success(response.data.response);
      })
      .catch((error) => {
        if (error.response.status == '501') {
        } else {
          toast.error(error.response.data.response);
        }
      });
  };
};
const getReleaseLockDetailsApi = (data) => {
  const config = {
    headers: {
      Authorization: secureLocalStorage.getItem('aTk'),
    },
    params: data,
  };
  var result;
  result = axios.get('release-lock', config);
  return result;
};

//get default values customer master x ref
export const getDefaultValuesCustomerXRef = () => {
  return (dispatch) => {
    getDefaultValuesCustomerXRefApi()
      .then((response) => {
        dispatch(getDefaultValuesCustomerXRefSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error('Something went wrong!')
      });
  };
};

const getDefaultValuesCustomerXRefApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.get(
    'form_fields?form_id=IMA_CONFIG_XREF_CUSTOMER_MASTER&section=0&limit=0',
    { headers: headers },
  );
  return result;
};

export const getDefaultValuesCustomerXRefSuccess = (data) => {
  return {
    type: IMA_CONFIG_XREF_CUSTOMER_MASTER_SUCCESS,
    data,
  };
};

//get default values
export const getDefaultValuesCustomer = () => {
  return (dispatch) => {
    getDefaultValuesCustomerApi()
      .then((response) => {
        dispatch(getDefaultValuesCustomerApiSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getDefaultValuesCustomerApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.get(
    'form_fields?form_id=IMA_CONFIG_CUSTOMER_MASTER&limit=0',
    { headers: headers },
  );
  return result;
};

export const getDefaultValuesCustomerApiSuccess = (data) => {
  return {
    type: IMA_CONFIG_CUSTOMER_MASTER_SUCCESS,
    data,
  };
};
//get default values material x ref
export const getDefaultValuesMaterialXRef = () => {
  return (dispatch) => {
    getDefaultValuesMaterialXRefApi()
      .then((response) => {
        dispatch(
          getDefaultValuesMaterialXRefApiSuccess(response.data.response),
        );
      })
      .catch((error) => { });
  };
};

const getDefaultValuesMaterialXRefApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.get(
    'form_fields?form_id=IMA_CONFIG_XREF_MATERIAL_MASTER&section=0&limit=0',
    { headers: headers },
  );
  return result;
};

export const getDefaultValuesMaterialXRefApiSuccess = (data) => {
  return {
    type: IMA_CONFIG_XREF_MATERIAL_MASTER_SUCCESS,
    data,
  };
};

//Add Api Membership Roster

export const createMembershipRoster = (data, type, id, name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createMembershipRosterAPI(data, type, id, name)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') {
          toast.success(response.data.response);
          dispatch(getMembershipData(1, 0, 'membershipRoster'));
        } else {
          toast.success(response.data.response);
          history.push('/enrollment-roster-main');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createMembershipRosterAPI = (data, type, id, name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'delete') {
    result = axios.delete(
      'membership?membership_owner_id=' + id,
      //  +'&membership_owner_name=' + name
      { headers: headers },
    );
  } else if (type === 'edit') {
    result = axios.put('membership-new', data, { headers: headers });
  } else {
    var result = axios.post('membership-new', data, {
      headers: headers,
    });
  }
  return result;
};

//delete membership
export const deleteMembership = (id, type, memberID) => {
  return (dispatch) => {
    deleteMembershipApi(id, type)
      .then((response) => {
        toast.success(response.data.response);
        if (type == 'multiple')
          dispatch(getMembershipData(1, 0, 'displaybyMember'));
        else dispatch(getMembershipDetails(memberID, 'MembershipID'));
      })
      .catch((error) => {
        //toast.error('Something went wrong when deleting. ')
      });
  };
};

const deleteMembershipApi = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'multiple')
    result = axios.delete('membership/' + id, {
      headers: headers,
    });
  else result = axios.delete('membership/' + id, { headers: headers });
  return result;
};

//get membership details
export const getMembershipDetails = (id, type) => {
  return (dispatch) => {
    getMembershipDetailsApi(id, type)
      .then((response) => {
        dispatch(getMembershipDetailsSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMembershipDetailsApi = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'MembershipID') {
    result = axios.get(
      'membership?membership_owner_id=' + id + '&page=1&limit=0',
      { headers: headers },
    );
  } else {
    result = axios.get('membership/' + id, { headers: headers });
  }
  return result;
};

export const getMembershipDetailsSuccess = (data) => {
  return {
    type: MEMBERSHIP_DETAIL_SUCCESS,
    data,
  };
};

//get list membership
export const getMembershipData = (pagination, limit, keyword, data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMembershipDataApi(pagination, limit, keyword, data).then((response) => {
      dispatch(fetchEnd());
      if (keyword === 'displaybyFilter') {
        dispatch(getMembershipDataSuccess(response.data.response));
        history.push({
          pathname: '/membership-by-member',
          state: 'displaybyFilter',
        });
      } else {
        dispatch(getMembershipDataSuccess(response.data.response));
      }
    });
  };
};

const getMembershipDataApi = (pagination, limit, keyword, data) => {
  for (var propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (keyword === 'displaybyMember') {
    result = axios.get('membership?display_by_member=true&&page=1&&limit=0', {
      headers: headers,
    });
  } else if (keyword === 'membershipRoster') {
    result = axios.get('membership-master', { headers: headers });
  } else if (keyword === 'displaybyFilter') {
    result = axios.get(
      'membership?display_by_member=true&&page=1&&limit=0',
      { params: data, headers: headers },
    );
  } else {
    result = axios.get('membership?page=1&&limit=0', { headers: headers });
  }
  return result;
};

export const getMembershipDataSuccess = (data) => {
  return {
    type: MEMBERSHIP_SUCCESS,
    data,
  };
};
//Membership Roster Bulk Edit Api
export const newUpdateMembershipRosterData = (formData, id, name) => {
  return (dispatch) => {
    newUpdateMembershipRosterDataApi(formData, id, name)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(getMembershipRosterDetailsById(id, name));
        history.push({
          pathname: '/enrollment-list/update/' + id,
          id: id,
        });
      })
      .catch((error) => {
        //toast.error("Error in updating data. Please try again.");
      });
  };
};

const newUpdateMembershipRosterDataApi = (formData, id, name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('membership-bulk-update', formData, {
    headers: headers,
  });
  return result;
};
//Membership Roster DataById
export const getMembershipRosterDetailsById = (id, name) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMembershipRosterDetailsByIdApi(id, name)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getMembershipRosterDetailsByIdSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMembershipRosterDetailsByIdApi = (id, name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'membership-master-id?membership_owner_id=' + id,
    // +'&membership_owner_name=' + name
    { headers: headers },
  );
  return result;
};

export const getMembershipRosterDetailsByIdSuccess = (data) => {
  return {
    type: MEMBERSHIP_ROSTER_DETAILBYID_SUCCESS,
    data,
  };
};

//Membership Customer Upload
export const membershipCustomerUploadFile = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    membershipCustomerUploadFileApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(membershipCustomerUploadFileResponse(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};

const membershipCustomerUploadFileApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  result = axios.post(
    'upload-file-cache?format_id=MembershipsCustomerUpload',
    data,
    { headers: headers },
  );
  return result;
};
export const membershipCustomerUploadFileResponse = (data) => {
  return {
    type: UPLOAD_MEMBERSHIP_CUSTOMER_UPLOAD_SUCCESS,
    data,
  };
};

//get list membership format
export const getMembershipFormatData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMembershipFormatDataApi(type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getMembershipFormatDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMembershipFormatDataApi = (type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('upload-format?app-functionality=' + type, {
    headers: headers,
  });
  return result;
};

export const getMembershipFormatDataSuccess = (data) => {
  return {
    type: MEMBERSHIP_FORMAT_SUCCESS,
    data,
  };
};

//get membership format data by id
export const getMembershipFormatDataById = (id, type) => {
  return (dispatch) => {
    getMembershipFormatDataByIdApi(id, type)
      .then((response) => {
        dispatch(getMembershipFormatDataByIdSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMembershipFormatDataByIdApi = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('upload-format/' + id + '?app-functionality=' + type, {
    headers: headers,
  });
  return result;
};

export const getMembershipFormatDataByIdSuccess = (data) => {
  return {
    type: MEMBERSHIP_FORMAT_BY_ID_SUCCESS,
    data,
  };
};

//get membership format fields
export const getMembershipFormatFields = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getMembershipFormatFieldsApi(type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getMembershipFormatFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getMembershipFormatFieldsApi = (type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('upload-format-fields?app-functionality=' + type, {
    headers: headers,
  });
  return result;
};

export const getMembershipFormatFieldsSuccess = (data) => {
  return {
    type: MEMBERSHIP_FORMAT_FIELDS_SUCCESS,
    data,
  };
};

// update membership format
export const updateMembershipFormatData = (id, data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateMembershipFormatDataApi(id, data, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success(response.data.response);
          history.push({
            pathname: '/membership/membership-excel-upload',
            state: type,
          });
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const updateMembershipFormatDataApi = (id, data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'upload-format/' + id + '?app-functionality=' + type,
    data,
    { headers: headers },
  );
  return result;
};

//add membership format
export const addMembershipFormatData = (data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addMembershipFormatDataApi(data, type)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
        history.push({
          pathname: '/membership/membership-excel-upload',
          state: type,
        });
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const addMembershipFormatDataApi = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('upload-format?app-functionality=' + type, data, {
    headers: headers,
  });
  return result;
};

// delete membership format
export const deleteMembershipFormatData = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    deleteMembershipFormatDataApi(id, type)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.status === 201) {
          toast.success('Successfully deleted');
          dispatch(getMembershipFormatData(type));
        } else {
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const deleteMembershipFormatDataApi = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('upload-format/' + id, { headers: headers });
  return result;
};

export const uploadMembershipFile = (id, file, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadMembershipFileApi(id, file, type)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchEnd());
          dispatch(uploadMembershipSuccess(response.data.response));
          if (
            response.data.response &&
            response.data.response.error_list == null
          ) {
            toast.success(response.data.response.success_msg);
          }
        } else {
          dispatch(fetchEnd());
          //toast.error(ServerError);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.complete_error_message);
      });
  };
};

const uploadMembershipFileApi = (id, file, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  if (
    type === 'MembershipGPORosterFormats' ||
    type === 'MembershipGPOTierActivationFormats' ||
    type === 'MembershipContractXREFFormats'
  ) {
    result = axios.post('upload-file?format_id=' + id, file, {
      headers: headers,
    });
  } else {
    result = axios.post('membership-data-upload?format_id=' + id, file, {
      headers: headers,
    });
  }
  return result;
};
export const uploadMembershipSuccess = (data) => {
  return {
    type: MEMBERSHIP_UPLOAD_SUCCESS,
    data,
  };
};

export const uploadEnrollmentUpdateRequest = (params, file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return uploadEnrollmentUpdateRequestApi(params, file)
      .then((response) => {
        dispatch(fetchEnd());
        const message = response.data?.response?.message || response.data?.message || 'File uploaded successfully.';
        appToast.showSuccess(message);
        return response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        return Promise.resolve({ success: false, error });
      });
  };
};

const uploadEnrollmentUpdateRequestApi = (params, file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const queryString = new URLSearchParams(params).toString();
  const url = queryString
    ? `membership-update-request/upload?${queryString}`
    : 'membership-update-request/upload';
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(url, formData, { headers });
};
//membership hierarchy
export const getMembershipHierarchyData = (id, type) => {
  return (dispatch) => {
    getMembershipHierarchyDataApi(id, type)
      .then((response) => {
        dispatch(getMembershipHierarchyDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getMembershipHierarchyDataApi = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'GPONumber') {
    var result = axios.get('gpo-hierarchy?gpo_member_number=' + id, {
      headers: headers,
    });
  } else {
    var result = axios.get(
      'membership-hierarchy-relation?membership_owner_id=' + id,
      { headers: headers },
    );
  }
  return result;
};

export const getMembershipHierarchyDataSuccess = (data) => {
  return {
    type: MEMBERSHIP_HIERARCHY_SUCCESS,
    data,
  };
};

//Sales Commission Apis
export const getSalesCommissionConfigDataById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSalesCommissionConfigDataByIdApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getSalesCommissionConfigDataByIdSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getSalesCommissionConfigDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'sc/config-commission/' + id,
    { headers: headers },
  );
  return result;
};

export const getSalesCommissionConfigDataByIdSuccess = (data) => {
  return {
    type: SALES_COMMISSION_CONFIG_DETAILBYID_SUCCESS,
    data,
  };
};

export const getSalesCommissionConfigData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSalesCommissionConfigDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getSalesCommissionConfigDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data.error.message);
      });
  };
};

const getSalesCommissionConfigDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'sc/config-commission',
    { headers: headers },
  );
  return result;
};

export const getSalesCommissionConfigDataSuccess = (data) => {
  return {
    type: SALES_COMMISSION_CONFIG_SUCCESS,
    data,
  };
};

export const createSalesCommissionConfig = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createSalesCommissionConfigAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'delete') {
          toast.success(response.data.response);
          dispatch(getSalesCommissionConfigData());
        } else {
          toast.success(response.data.response);
          history.push('/sales-commission-configuration');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createSalesCommissionConfigAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'delete') {
    result = axios.delete(
      'sc/config-commission/' + id,
      { headers: headers },
    );
  } else if (type === 'edit') {
    result = axios.put('sc/config-commission/' + id, data, { headers: headers });
  } else {
    var result = axios.post('sc/config-commission', data, {
      headers: headers,
    });
  }
  return result;
};

export const getScTrackAndTraceData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart1());
    getScTrackAndTraceDataApi(data)
      .then((response) => {
        // if (response.data.response && response.data.response.length > 0)
        dispatch(getScTrackAndTraceDataSuccess(response.data));
        history.push('/sales-commission/track-and-trace-result');
        dispatch(fetchEnd1());
      })
      .catch((error) => {
        dispatch(fetchEnd1());
        //toast.error(ServerError);
        // history.push('/sales-commission/track-and-trace-result');
      });
  };
};

const getScTrackAndTraceDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('sales-commission-trace', data, { headers: headers });
  return result;
};

export const getScTrackAndTraceDataSuccess = (data) => {
  return {
    type: SC_TRACK_AND_TRACE_DATA_SUCCESS,
    data,
  };
};

export const getScBaseConfigData = (noloader) => {
  return (dispatch) => {
    if (!noloader)
      dispatch(fetchStart());
    getScBaseConfigDataApi()
      .then((response) => {
        if (!noloader)
          dispatch(fetchEnd());
        dispatch(getScBaseConfigDataSuccess(response.data.response));
      })
      .catch((error) => {
        if (!noloader)
          dispatch(fetchEnd());
        dispatch(getScBaseConfigDataSuccess({}));
      });
  };
};

const getScBaseConfigDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('sc/config-commission-setup', { headers: headers });
  return result;
};

export const getScBaseConfigDataSuccess = (data) => {
  return {
    type: SC_BASE_CONFIG_DATA_SUCCESS,
    data,
  };
};

export const createScBaseConfigData = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    createScBaseConfigDataAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        dispatch(getScBaseConfigData());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const createScBaseConfigDataAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  if (type === 'edit') {
    result = axios.put('sc/config-commission-setup/' + id, data, { headers: headers });
  } else {
    var result = axios.post('sc/config-commission-setup', data, {
      headers: headers,
    });
  }
  return result;
};

export const getChangeLogeData = (data, type, apiPath, breadcrumb) => {
  return (dispatch) => {
    dispatch(fetchStart());
    return getChangeLogeDataApi(data, apiPath || (type === 'individual' ? 'change-log' : 'change-log-all'))
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getChangeLogeDataSuccess(response.data.response));
        const hasData =
          (Array.isArray(response?.data?.response) && response?.data?.response.length > 0);
        if (hasData) {
          history.push({
            pathname: '/changelog-search-result',
            state: breadcrumb ? { breadcrumb } : undefined,
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch(fetchEnd());
        throw error;
      });
  };
};

const getChangeLogeDataApi = (data, api) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(api, data, { headers: headers });
  return result;
};
export const getChangeLogeDataSuccess = (data) => {
  return {
    type: CHANGE_LOG_DATA_SUCCESS,
    data,
  };
};
export const getScTrackAndTraceLogData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getScTrackAndTraceLogDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        // if (response.data.response && response.data.response.length > 0)
        dispatch(getScTrackAndTraceLogDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getScTrackAndTraceLogDataSuccess({}));
        //toast.error(ServerError);
      });
  };
};


export const getPricingLogsById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());

    getPricingLogsByIdApi(id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPricingLogsByIdSuccess(response.data?.response || []));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getPricingLogsByIdSuccess([]));
        // toast.error(ServerError);
      });
  };
};

const getPricingLogsByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem("aTk"),
  };

  return axios.get(`pricing/logs/${id}`, { headers });
};
export const getPricingLogsByIdSuccess = (data) => {
  return {
    type: PRICING_LOGS_BY_ID_SUCCESS,
    data,
  };
};
const getScTrackAndTraceLogDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('execution-log', data, { headers: headers });
  return result;
};

export const getScTrackAndTraceLogDataSuccess = (data) => {
  return {
    type: SC_TRACK_AND_TRACE_LOG_DATA_SUCCESS,
    data,
  };
};

export const clearScTrackAndTraceLogData = (data) => {
  return {
    type: SC_TRACK_AND_TRACE_LOG_DATA_CLEAR,
    data,
  };
};

//get bom details
// export const getBomDetails = (id) => {
//   console.log(id)
//   return (dispatch) => {
//     getBomDetailsApi(id)
//       .then((response) => {
//         dispatch(getBomDetailsSuccess(response.data.response));
//       })
//       .catch((error) => {
//         //toast.error(error.response.data.error.message);
//       });
//   };
// };

// const getBomDetailsApi = (id) => {
//   const headers = {
//     Authorization: secureLocalStorage.getItem('aTk'),
//   };
//   var result;
//   result = axios.get('bom/' + id, { headers: headers });
//   return result;
// };

// export const getBomDetailsSuccess = (data) => {
//   return {
//     type: BOM_DETAIL_SUCCESS,
//     data,
//   };
// };
//get employee data
export const getEmployeeData = (pagination, limit) => {
  return (dispatch) => {
    getEmployeeDataApi(pagination, limit)
      .then((response) => {
        dispatch(getEmployeeDataApiSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getEmployeeDataApi = (pagination, limit, keyword) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  let result;
  result = axios.get('employee?page=1&&limit=0', { headers: headers });
  return result;
};

export const getEmployeeDataApiSuccess = (data) => {
  return {
    type: EMPLOYEE_MASTER_SUCCESS,
    data,
  };
};
//add employee
export const addEmployeeData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addEmployeeApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success('Successfully added.');
        history.push('/employee');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addEmployeeApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('employee', data, { headers: headers });
  return result;
};

export const getEmployeeMasterViewDetails = (id, mode) => {
  return (dispatch) => {
    getEmployeeMasterViewDetailsApi(id).then((response) => {
      if (mode != 'edit') history.push('/employee/view-employee/' + id);
      dispatch(getEmployeeMasterViewDetailsApiSuccess(response.data.response));
    });
  };
};
const getEmployeeMasterViewDetailsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('employee/' + id, { headers: headers });
  return result;
};

export const getEmployeeMasterViewDetailsApiSuccess = (data) => {
  return {
    type: EMPLOYEE_MASTER_VIEW_DETAIL_SUCCESS,
    data,
  };
};

export const putEmployeeData = (data, id) => {
  return (dispatch) => {
    putEmployeeDataApi(data, id).then((response) => {
      toast.success('Successfully updated.');
      history.push('/employee');
    });
  };
};

const putEmployeeDataApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('employee/' + id, data, { headers: headers });
  return result;
};

//integration studio
export const addIntegrationSetup = (data) => {
  return (dispatch) => {
    addIntegrationSetupApi(data)
      .then((response) => {
        history.push('/integration-setup');
        toast.success('Successfully added.');
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const addIntegrationSetupApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    'integration-setup?application_type=' +
    sessionStorage.getItem('application'),
    data,
    { headers: headers },
  );
  return result;
};

// get filter name dropdown list
export const getFilterNameList = (activity, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFilterNameApi(activity, type)
      .then((response) => {
        dispatch(getFilterNameDataSuccess(response.data.filter_name));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getFilterListDataFailed(error));
      });
  };
};

const getFilterNameApi = (activity, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'date') {
    var result = axios.get(
      'integration-setup/filters?application_type=' +
      sessionStorage.getItem('application') +
      '&activity=' +
      activity +
      '&type=date',
      { headers: headers },
    );
  } else {
    var result = axios.get(
      'integration-setup/filters?application_type=' +
      sessionStorage.getItem('application') +
      '&activity=' +
      activity,
      { headers: headers },
    );
  }
  return result;
};
export const getFilterNameDataSuccess = (data) => {
  return {
    type: FILTER_LIST_SUCCESS,
    data,
  };
};
export const getFilterListDataFailed = (error) => {
  return {
    type: FILTER_LIST_FAIL,
    error,
  };
};

// get integration by id
export const getIntegrationById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationByIdApi(id)
      .then((response) => {
        dispatch(getIntegrationByIdSuccess(response.data.response));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getFilterListDataFailed(error));
      });
  };
};

const getIntegrationByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'integration-setup/' + id,
    { headers: headers },
  );
  return result;
};

export const getIntegrationByIdSuccess = (data) => {
  return {
    type: INTEGRATION_BY_ID_SUCCESS,
    data,
  };
};

// get filter by Id for integration manager
export const getFilterById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getFilterByIdApi(id)
      .then((response) => {
        dispatch(getFilterByIdDataSuccess(response.data.filters));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getFilterByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'integration-setup/filters/' +
    id +
    '?application_type=' +
    sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};
export const getFilterByIdDataSuccess = (data) => {
  return {
    type: FILTER_BY_ID_LIST_SUCCESS,
    data,
  };
};
//Data Update Api
export const updateData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateDataApi(data)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error("Unidentified error");
      });
  };
};

const updateDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.put('update-data', data, {
      headers: headers,
    });
  }
  return result;
};
//New Integration InBound
export const fetchIntegrationExecutionData = (data, useExecuteApi) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await fetchIntegrationExecutionDataApi(data, useExecuteApi);
      dispatch(fetchEnd());
      const logNumber = response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      } else {
        toast.success(response.data.response);
      }
    } catch (error) {
      dispatch(fetchEnd());
      const logNumber = error?.response?.data?.log_number;
      if (logNumber) {
        await handleExecutionLog(dispatch, logNumber);
      }
    }
  };
};

const fetchIntegrationExecutionDataApi = (data, useExecuteApi) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const url = useExecuteApi ? 'integration/execute' : 'integration/run';
  return axios.post(url, data, {
    headers: headers,
  });
};

export const getIntegrationStagingData = (data, showError) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationStagingDataApi(data, showError)
      .then((response) => {
        dispatch(fetchEnd());
        // if (response.data.response && response.data.response.length > 0)
        dispatch(getIntegrationStagingDataSuccess(response.data.response));
        history.push('/integration-dashboard-result-page');
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const getIntegrationStagingDataApi = (data, showError) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  const queryParam = `?show_reconciliation_error=${showError}`;
  result = axios.post(`integration-staging${queryParam}`, data, { headers: headers });
  return result;
};

export const getIntegrationStagingDataSuccess = (data) => {
  return {
    type: INTEGRATION_STAGING_DATA_SUCCESS,
    data,
  };
};
export const getIntegrationProfileData = (direction, params) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationProfileDataApi(direction, params)
      .then((response) => {
        dispatch(fetchEnd());
        // if (response.data.response && response.data.response.length > 0)
        dispatch(getIntegrationProfileDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};
const getIntegrationProfileDataApi = (direction, params) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (params) {
    result = axios.get(`integration-profile`, { params: params, headers: headers });
  }
  else
    result = axios.get(
      direction
        ? `integration-profile?direction=${direction}`
        : 'integration-profile?direction=all',
      { headers: headers },
    );
  return result;
};

// const getIntegrationProfileDataApi = () => {
//   const headers = {
//     Authorization: secureLocalStorage.getItem('aTk'),
//   };
//   var result;
//   result = axios.get('integration-profile', { headers: headers });
//   return result;
// };

export const getIntegrationProfileDataSuccess = (data) => {
  return {
    type: INTEGRATION_PROFILE_DATA_SUCCESS,
    data,
  };
};

export const addIntegrationProfileData = (data, type, id, direction) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addIntegrationProfileDataAPI(data, type, id, direction)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        if (direction === 'outbound') {
          history.push('/integration-profile-outbound');
          dispatch(getIntegrationProfileData('outbound'));
        }
        else {
          history.push('/integration-profile');
          dispatch(getIntegrationProfileData('inbound'));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addIntegrationProfileDataAPI = (data, type, id, direction) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('integration-profile/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('integration-profile/' + id, { headers: headers });
  } else {
    result = axios.post('integration-profile', data, { headers: headers });
  }
  return result;
};

export const getIntegrationConnectionData = (type) => {
  return (dispatch) => {
    dispatch(getIntegrationConnectionDataSuccess(null, true));
    // dispatch(fetchStart());
    getIntegrationConnectionDataApi(type)
      .then((response) => {
        // dispatch(fetchEnd());
        // if (response.data.response && response.data.response.length > 0)
        dispatch(getIntegrationConnectionDataSuccess(response.data.response, false));
      })
      .catch((error) => {
        // dispatch(fetchEnd());
        dispatch(getIntegrationConnectionDataSuccess(null, false));
        //toast.error(ServerError);
      });
  };
};

const getIntegrationConnectionDataApi = (type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'noStatus') {
    result = axios.get('integration-connections?status=false', {
      headers: headers,
    });
  } else {
    result = axios.get('integration-connections', { headers: headers });
  }
  return result;
};

export const getIntegrationConnectionDataSuccess = (data, loader) => {
  return {
    type: INTEGRATION_CONNECTION_DATA_SUCCESS,
    data,
    loader,
  };
};
export const getIntegrationConnectionDataNoStatus = (loader) => {
  return (dispatch) => {
    if (loader !== "no loader")
      dispatch(fetchStart());
    getIntegrationConnectionDataNoStatusApi(loader)
      .then((response) => {
        if (loader !== "no loader")
          dispatch(fetchEnd());
        // if (response.data.response && response.data.response.length > 0)
        dispatch(getIntegrationConnectionDataNoStatusSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const getIntegrationConnectionDataNoStatusApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-connections?status=false', {
    headers: headers,
  });
  return result;
};

export const getIntegrationConnectionDataNoStatusSuccess = (data) => {
  return {
    type: INTEGRATION_CONNECTION_DATA_NO_STATUS_SUCCESS,
    data,
  };
};
// Single Integration Connection Data
export const getSingleIntegrationConnectionData = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSingleIntegrationConnectionDataApi(data)
      .then((response) => {
        dispatch(fetchEnd());
        // if (response.data.response && response.data.response.length > 0)
        dispatch(
          getSingleIntegrationConnectionDataSuccess(response.data.response),
        );
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const getSingleIntegrationConnectionDataApi = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('integration-connections/ping', data, {
    headers: headers,
  });
  return result;
};

export const getSingleIntegrationConnectionDataSuccess = (data) => {
  return {
    type: SINGLE_INTEGRATION_CONNECTION_DATA_SUCCESS,
    data,
  };
};

// Add/Edit Integration Connection Data
export const addIntegrationConnectionData = (data, type, id, statusType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addIntegrationConnectionDataAPI(data, type, id, statusType)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/integration-connection-profile');
        toast.success(response.data.response);
        dispatch(getIntegrationConnectionDataNoStatus());
        setTimeout(() => {
          dispatch(getIntegrationConnectionData());
        }, 500); // wait 0.5s (tweak as needed)
        // dispatch(getIntegrationConnectionDataNoStatus());
        // dispatch(getIntegrationConnectionData());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addIntegrationConnectionDataAPI = (data, type, id, statusType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    result = axios.put('integration-connections/' + id, data, {
      headers: headers,
    });
  } else if (type === "StatusChange") {
    result = axios.put('integration-connections/' + id + '?disconnected=' + statusType, data, {
      headers: headers,
    });
  } else {
    result = axios.post('integration-connections', data, { headers: headers });
  }
  return result;
};

// Delete Integration Connection Data
export const deleteIntegrationConnectionData = (id) => {
  return (dispatch) => {
    deleteIntegrationConnectionDataApi(id)
      .then((response) => {
        history.push('/integration-connection-profile');
        toast.success(response.data.response);
        dispatch(getIntegrationConnectionDataNoStatus());
        setTimeout(() => {
          dispatch(getIntegrationConnectionData());
        }, 500);
      })
      .catch((error) => {
        //toast.error("Unidentified error");
      });
  };
};

const deleteIntegrationConnectionDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('integration-connections' + '/' + id, {
    headers: headers,
  });
  return result;
};
// list integration setup
export const getIntegrationSetupData = (
  pagination,
  limit,
  activity,
  application,
) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationSetupDataApi(pagination, limit, activity, application)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response && response.data.response.records.length > 0)
          dispatch(getIntegrationSetupDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(ServerError);
      });
  };
};

const getIntegrationSetupDataApi = (
  pagination,
  limit,
  activity,
  application,
) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (activity) {
    result = axios.get(
      'integration-setup?application_type=' +
      (application == undefined
        ? sessionStorage.getItem('application')
        : application) +
      '&&page=' +
      pagination +
      '&&limit=' +
      limit +
      '&&activity=' +
      activity,
      { headers: headers },
    );
  } else {
    result = axios.get(
      'integration-setup?application_type=' +
      (application == undefined
        ? sessionStorage.getItem('application')
        : application) +
      '&&page=' +
      pagination +
      '&&limit=' +
      limit,
      { headers: headers },
    );
  }
  return result;
};

export const getIntegrationSetupDataSuccess = (data) => {
  return {
    type: INTEGRATION_SETUP_SUCCESS,
    data,
  };
};

// Track User Activity

export const getTrackActivityData = (applicationType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTrackActivityDataApi(applicationType)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getTrackActivityDataSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getTrackActivityDataApi = (applicationType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (applicationType == 'Platform Administration') {
    result = axios.get('active-requests?all=true', { headers: headers });
  }
  else {
    result = axios.get('active-requests', { headers: headers });
  }
  return result;
};

export const getTrackActivityDataSuccess = (data) => {
  return {
    type: TRACK_ACTIVITY_SUCCESS,
    data,
  };
};

export const getCancelTrackActivity = (id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCancelTrackActivityApi(id, type)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.message);
      })
      .catch((error) => {
        //toast.error(ServerError);
        dispatch(fetchEnd());
      });
  };
};

const getCancelTrackActivityApi = (id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'BATCH_JOB') {
    result = axios.post('batch/cancel/batch_job_cancel?batch_job_id=' + id, { headers: headers });
  } else {
    result = axios.post('cancel/' + id, { headers: headers });
  }
  return result;
};

//Trigger integration
export const triggerIntegration = (id, data, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    triggerIntegrationApi(id, data, type)
      .then((response) => {
        // if (response.data.response && response.data.response.error) {
        //   dispatch(fetchEnd());
        //   toast.error(response.data.response.error.join(', '));
        //   return; // Exit early to avoid executing the success logic
        // }
        if (type == 'Postings - Customer-Material') {
          dispatch(fetchEnd());
          toast.success(response.data.response['message']);
          // toast.success(
          //   'Records Saved Count ' +
          //   response.data.response['records Processed'],
          // );
          if (type == 'Postings - Customer-Material') {
            const element = document.createElement('a');
            const file = new Blob([response.data.response.data], {
              type: 'text/csv',
            });
            element.href = URL.createObjectURL(file);
            element.download = response.data.response.file_name;
            document.body.appendChild(element);
            element.click();
          }
        } else if (
          type === 'Document Management' ||
          type === 'Sales Reconcilation' ||
          [
            'Customer Master',
            'Material Master',
            'Supplier Master',
            'Direct - Sales Data',
            'Customer Stat Data',
            'Legacy Calculation Data',
          ].includes(type)
        ) {
          dispatch(fetchEnd());
          toast.success(response.data.response['message']);
          // toast.success(
          //   'Records Processed Count ' +
          //   response.data.response['records_saved_count'],
          // );
        } else if (type === 'Contract Calculation Rules') {
          dispatch(fetchEnd());
          toast.success(
            'Records Processed: ' + response.data.response['recordsProcessed'],
          );
        } else if (type === 'COPA') {
          dispatch(fetchEnd());
          toast.success(
            'Records Processed: ' + response.data.response['recordsProcessed'],
          );
        } else if (type === 'Daily Simulation Integration') {
          dispatch(fetchEnd());
          toast.success(
            'Records Processed: ' + response.data.response['recordsProcessed'],
          );
        } else {
          dispatch(fetchEnd());
          toast.success(response.data.response['message']);
          // toast.success(
          //   'Records Processed: ' + response.data.response['recordsProcessed'],
          // );
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const triggerIntegrationApi = (id, data, type) => {
  try {
    const headers = {
      Authorization: secureLocalStorage.getItem('aTk'),
    };
    var result;
    if (type == 'COPA') {
      result = axios.post('tlp-posting-api/' + id, data, { headers: headers });
    } else if (type == 'Daily Simulation Integration') {
      result = axios.post('daily-simulation-integration-api/' + id, data, {
        headers: headers,
      });
    } else {
      result = axios.post(
        'integration-setup/' +
        id +
        '/manual' +
        '?application_type=' +
        sessionStorage.getItem('application'),
        data,
        { headers: headers },
      );
    }
    return result;
  } catch (error) {
    // console.log(error);
  }
};

//integration studio edit

// fetch integration setup
export const fetchIntegrationSetup = (id) => {
  return (dispatch) => {
    fetchIntegrationSetupApi(id)
      .then((response) => {
        dispatch(fetchIntegrationSetupDataSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error("Unidentified error");
      });
  };
};

const fetchIntegrationSetupApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-setup/' + id, { headers: headers });
  return result;
};
export const fetchIntegrationSetupDataSuccess = (data) => {
  return {
    type: FECTCH_INTEGRATION_SETUP_SUCCESS,
    data,
  };
};

export const editIntegrationSetup = (id, data) => {
  return (dispatch) => {
    editIntegrationSetupApi(id, data)
      .then((response) => {
        history.push('/integration-setup');
        toast.success('Successfully updated.');
        dispatch(getIntegrationSetupData(1, 20));
      })
      .catch((error) => {
        //toast.error("Unidentified error");
      });
  };
};

const editIntegrationSetupApi = (id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put(
    'integration-setup/' +
    id +
    '?application_type=' +
    sessionStorage.getItem('application'),
    data,
    { headers: headers },
  );
  return result;
};
// delete integration

export const deleteIntegrationSetup = (id) => {
  return (dispatch) => {
    deleteIntegrationSetupApi(id)
      .then((response) => {
        history.push('/integration-setup');
        toast.success(response.data.response);
        dispatch(getIntegrationSetupData(1, 20));
      })
      .catch((error) => {
        //toast.error("Unidentified error");
      });
  };
};

const deleteIntegrationSetupApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete(
    'integration-setup/' +
    id +
    '?application_type=' +
    sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};

// Integration Manager history
export const imHistory = (id, pagination, limit) => {
  return (dispatch) => {
    imHistoryAPI(id, pagination, limit).then((response) => {
      dispatch(imHistorySuccess(response.data.response));
      if (response && response.data && response.data.response) {
        history.push('/integration-manager/im-history/' + id);
      } else {
        toast.warn('No Records Found.');
      }
    });
  };
};

const imHistoryAPI = (id, pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const result = axios.get(
    'integration-setup-history/' +
    id +
    '?page=' +
    pagination +
    '&limit=' +
    limit,
    { headers: headers },
  );
  return result;
};

export const imHistorySuccess = (data) => {
  return {
    type: IM_HISTORY_SUCCESS,
    data,
  };
};

//get list all territory
export const getTerritoryData = (pagination, limit, keyword) => {
  return (dispatch) => {
    getTerritoryDataApi(pagination, limit, keyword)
      .then((response) => {
        dispatch(getTerritoryDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getTerritoryDataApi = (pagination, limit, keyword) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (keyword) {
    result = axios.get('territory?keyword=' + keyword, { headers: headers });
  } else {
    result = axios.get('territory', { headers: headers });
  }
  return result;
};

export const getTerritoryDataSuccess = (data) => {
  return {
    type: TERRITORY_SUCCESS,
    data,
  };
};
//get territory
export const getTerritoryListData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getTerritoryListDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getTerritoryListDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getTerritoryListDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.get('territory-masters', { headers: headers });

  return result;
};

export const getTerritoryListDataSuccess = (data) => {
  return {
    type: TERRITORY_LIST_SUCCESS,
    data,
  };
};
//single territory

export const getSingleTerritoryData = (id) => {
  return (dispatch) => {
    getSingleTerritoryDataApi(id)
      .then((response) => {
        dispatch(getSingleTerritoryDataSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getSingleTerritoryDataApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  //var result = axios.get('territory/' + id, { headers: headers });
  var result = axios.get('territory-hierarchy?id=' + id, { headers: headers });
  return result;
};

export const getSingleTerritoryDataSuccess = (data) => {
  return {
    type: TERRITORY_SINGLE_SUCCESS,
    data,
  };
};

//approval designer
export const getAllApprovalDesigner = (pagination, limit) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAllApprovalDesignerAPI(pagination, limit).then((response) => {
      dispatch(getAllApprovalDesignerSuccess(response.data.response));
      dispatch(fetchEnd());
    });
  };
};

const getAllApprovalDesignerAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('workflow-setup', { headers: headers });
  return result;
};

export const getAllApprovalDesignerSuccess = (data) => {
  return {
    type: APPROVAL_DESIGNER_GET_SUCCESS,
    data,
  };
};

export const addApprovalDesigner = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addApprovalDesignerAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/approval-limits');
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addApprovalDesignerAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('workflow-setup/' + id, data, { headers: headers });
  } else {
    result = axios.post('workflow-setup', data, { headers: headers });
  }
  return result;
};

export const getApprovalDesignerDetails = (id) => {
  return (dispatch) => {
    getApprovalDesignerDetailsAPI(id).then((response) => {
      dispatch(getApprovalDesignerDetailsSuccess(response.data.response));
    });
  };
};

const getApprovalDesignerDetailsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('workflow-setup/' + id, { headers: headers });
  return result;
};

export const getApprovalDesignerDetailsSuccess = (data) => {
  return {
    type: APPROVAL_DESIGNER_DETAIL_SUCCESS,
    data,
  };
};

export const deleteApprovalDesigner = (id) => {
  return (dispatch) => {
    deleteApprovalDesignerAPI(id).then((response) => {
      toast.success(response.data.response);
      dispatch(getAllApprovalDesigner());
    });
  };
};

const deleteApprovalDesignerAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('workflow-setup/' + id, { headers: headers });
  return result;
};

//contract default
export const getContractDefaultDesigner = (pagination, limit) => {
  return (dispatch) => {
    getContractDefaultDesignerAPI(pagination, limit).then((response) => {
      dispatch(getContractDefaultDesignerSuccess(response.data.response));
    });
  };
};

const getContractDefaultDesignerAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('default-all?page=' + pagination + '&limit=' + limit, {
    headers: headers,
  });
  return result;
};

export const getContractDefaultDesignerSuccess = (data) => {
  return {
    type: CONTRACT_DEFAULT_DESIGNER_SUCCESS,
    data,
  };
};

export const addContractDefaultDesigner = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addContractDefaultDesignerAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());

        if (type === 'delete') {
          dispatch(getContractDefaultDesigner());
          toast.success('Successfully deleted.');
        } else {
          history.push('/contract-default-designer');
          toast.success('Successfully added.');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addContractDefaultDesignerAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('default/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('default/' + id, data, { headers: headers });
  } else {
    result = axios.post('default', data[0], { headers: headers });
  }
  return result;
};

export const getContractDefaultDetails = (id) => {
  return (dispatch) => {
    getContractDefaultDetailsAPI(id).then((response) => {
      dispatch(getContractDefaultDetailsSuccess(response.data.response));
    });
  };
};

const getContractDefaultDetailsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('default?default_id=' + id, { headers: headers });
  return result;
};

export const getContractDefaultDetailsSuccess = (data) => {
  return {
    type: CONTRACT_DEFAULT_DETAIL_SUCCESS,
    data,
  };
};

//payment designer
export const getAllPaymentDesigner = (pagination, limit) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAllPaymentDesignerAPI(pagination, limit).then((response) => {
      dispatch(fetchEnd());
      dispatch(getAllPaymentDesignerSuccess(response.data.response));
    });
  };
};

const getAllPaymentDesignerAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'payment-designer-all?page=' + pagination + '&&limit=' + limit,
    { headers: headers },
  );
  return result;
};

export const getAllPaymentDesignerSuccess = (data) => {
  return {
    type: PAYMENT_DESIGNER_GET_SUCCESS,
    data,
  };
};
export const deletePaymentDesigner = (id) => {
  return (dispatch) => {
    deletePaymentDesignerAPI(id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(getAllPaymentDesigner());
      })
      .catch((error) => { });
  };
};

const deletePaymentDesignerAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('payment-designer/' + id, { headers: headers });

  return result;
};

//accrual designer
export const getAllAccrualDesigner = (pagination, limit) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAllAccrualDesignerAPI(pagination, limit)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getAllAccrualDesignerSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getAllAccrualDesignerAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'accrual-designer-all?page=' + pagination + '&limit=' + limit,
    { headers: headers },
  );
  return result;
};

export const getAllAccrualDesignerSuccess = (data) => {
  return {
    type: ACCRUAL_DESIGNER_GET_SUCCESS,
    data,
  };
};

//single
export const getAccrualDesignerSingleItem = (id) => {
  return (dispatch) => {
    getAccrualDesignerSingleItemAPI(id).then((response) => {
      dispatch(getAccrualDesignerSingleItemSuccess(response.data.response));
    });
  };
};

const getAccrualDesignerSingleItemAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('accrual-designer?id=' + id, { headers: headers });
  return result;
};

export const getAccrualDesignerSingleItemSuccess = (data) => {
  return {
    type: ACCRUAL_DESIGNER_SINGLE_SUCCESS,
    data,
  };
};

//single
export const getPaymentDesignerSingleItem = (id) => {
  return (dispatch) => {
    getPaymentDesignerSingleItemAPI(id).then((response) => {
      dispatch(getPaymentDesignerSingleItemSuccess(response.data.response));
    });
  };
};

const getPaymentDesignerSingleItemAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('payment-designer?id=' + id, { headers: headers });
  return result;
};

export const getPaymentDesignerSingleItemSuccess = (data) => {
  return {
    type: PAYMENT_DESIGNER_SINGLE_SUCCESS,
    data,
  };
};

export const addPaymentDesigner = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addPaymentDesignerAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/payment-designer');
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addPaymentDesignerAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('payment-designer/' + id, data, { headers: headers });
  } else {
    result = axios.post('payment-designer', data, { headers: headers });
  }
  return result;
};

export const addAccrualDesigner = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addAccrualDesignerAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/accrual-designer');
        toast.success('Accrual Designer created successfully.');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addAccrualDesignerAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'edit') {
    result = axios.put('accrual-designer/' + id, data, { headers: headers });
  } else {
    result = axios.post('accrual-designer', data, { headers: headers });
  }
  return result;
};
export const deleteAccrualDesigner = (id) => {
  return (dispatch) => {
    deleteAccrualDesignerAPI(id).then((response) => {
      toast.success('Successfully deleted');
      dispatch(getAllAccrualDesigner());
    });
  };
};

const deleteAccrualDesignerAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('accrual-designer/' + id, { headers: headers });
  return result;
};
//sales Basis
//get all sales basis
export const getAllSalesBasis = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getAllSalesBasisAPI().then((response) => {
      dispatch(getAllSalesBasisSuccess(response.data.response));
      dispatch(fetchEnd());
    });
  };
};

const getAllSalesBasisAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('universal-eligibility-rule', { headers: headers });
  return result;
};

export const getAllSalesBasisSuccess = (data) => {
  return {
    type: SALES_BASIS_ALL,
    data,
  };
};
export const getAllSalesBasisSuccessSingle = (data) => {
  return {
    type: SALES_BASIS_SINGLE,
    data,
  };
};

//add eligibility
export const addSalesBasis = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addSalesBasisAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());

        dispatch(getAllSalesBasis());
        toast.success(response.data.response);
        history.push('/sales-basis');
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addSalesBasisAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('universal-eligibility-rule/' + id, data, {
      headers: headers,
    });
  } else if (type === 'delete') {
    result = axios.delete('universal-eligibility-rule/' + id, {
      headers: headers,
    });
  } else {
    result = axios.post('universal-eligibility-rule', data, {
      headers: headers,
    });
  }
  return result;
};

export const getSingleSalesBasis = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getSingleSalesBasisAPI(id).then((response) => {
      dispatch(getSingleSalesBasisSuccessSingle(response.data.response));
      dispatch(fetchEnd());
    });
  };
};

const getSingleSalesBasisAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('universal-eligibility-rule/' + id, { headers: headers });
  return result;
};

export const getSingleSalesBasisSuccessSingle = (data) => {
  return {
    type: SALES_BASIS_SINGLE,
    data,
  };
};

//batch job
export const addNewBatchJobSetup = (data, type, data1) => {
  return (dispatch) => {
    dispatch(fetchStart());
    const finalizeBatchJob = (payload) => {
      return addNewBatchJobSetupAPI(payload)
        .then((response) => {
          dispatch(fetchEnd());
          toast.success(response.data.response);
          dispatch(getBatchJobSetup(sessionStorage.getItem('application')));
        })
        .catch((error) => {
          dispatch(fetchEnd());
        });
    };

    if (type === 'batchjob_onetime') {
      addDynamicFilterAPI(data1)
        .then((filterResponse) => {
          const newFilterId = filterResponse.data.created_id;
          // CHECK: If ID is missing or 0, don't proceed to batch creation
          if (!newFilterId) {
            dispatch(fetchEnd());
            toast.error("Failed to create a Batch Job.");
            return;
          }
          const updatedData = {
            ...data,
            batch_job_setup: data.batch_job_setup.map((job) => ({
              ...job,
              filter_id: newFilterId,
            })),
          };
          return finalizeBatchJob(updatedData);
        })
        .catch((error) => {
          dispatch(fetchEnd());
          toast.error("Failed to create a Batch Job.");
        });
    } else if (type === 'batchjob_filter_values') {
      dispatch(updateFilterValues(null, data1, { filter_group: data1?.filter_group }, 'No_Loader'))
        .then(() => finalizeBatchJob(data))
        .catch((error) => {
          dispatch(fetchEnd());
          toast.error("Failed to create a Batch Job.");
        });
    } else {
      finalizeBatchJob(data);
    }
  };
};

const addDynamicFilterAPI = (data1) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(
    'dynamic-query-filter?functionality=Batch Job',
    data1,
    { headers: headers }
  );
};

const addNewBatchJobSetupAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.post(
    'create-batch-job',
    data,
    { headers: headers }
  );
};
// export const addNewBatchJobSetup = (data, type, data1) => {
//   return (dispatch) => {
//     dispatch(fetchStart());
//     addNewBatchJobSetupAPI(data, type,)
//       .then((response) => {
//         dispatch(fetchEnd());
//         toast.success('Successfully added.');
//         dispatch(getBatchJobSetup(sessionStorage.getItem('application')));
//         // history.push({
//         //   pathname: '/batchjob-setup-new',
//         // });
//       })
//       .catch((error) => {
//         dispatch(fetchEnd());
//       });
//   };
// };

// const addNewBatchJobSetupAPI = (data, type) => {
//   const headers = {
//     Authorization: secureLocalStorage.getItem('aTk'),
//   };
//   var result;
//   result = axios.post(
//     'create-batch-job',
//     data,
//     { headers: headers },
//   );
//   return result;
// };
//
export const addBatchJobSetup = (data, edit, id, type, statusType) => {
  return (dispatch) => {
    addBatchJobSetupAPI(data, edit, id, type, statusType)
      .then((response) => {
        if (type === 'CustomerRebateForecast') {
          history.push('/profitopt-batchjob-setup');
        }
        else if (type === 'New Batch Job') {
          // history.push('/batchjob-setup-new');
        }
        else {
          history.push('/batchjob-setup');
        }
        if (edit === 'edit') toast.success('Successfully updated.');
        else if (edit === 'delete') {
          toast.success('Successfully deleted.');
          dispatch(getBatchJobSetup(sessionStorage.getItem('application'), statusType));
          // dispatch(getBatchJobSetup(sessionStorage.getItem('application'), "all"));
        } else {
          toast.success('Successfully added.');
        }
      })
      .catch((error) => { });
  };
};

const addBatchJobSetupAPI = (data, edit, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (edit === 'edit')
    result = axios.put('batch-job/' + id, data, { headers: headers });
  else if (edit === 'delete') {
    if (type === 'New Batch Job') {
      result = axios.delete('delete-batch-job/' + id, data, { headers: headers });
    }
    else {
      result = axios.delete('batch-job/' + id, data, { headers: headers });
    }
  }

  else result = axios.post('batch-job', data, { headers: headers });
  return result;
};

export const getBatchJobSetup = (type, status) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobSetupAPI(type, status)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobSetupSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobSetupAPI = (type, status) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type != 'Batch Jobs') {
    result = axios.get('batch-job?app_type=' + type, { headers: headers });
  } else {
    if (status === "one_time") {
      result = axios.get('batch-job?one_time=true', { headers: headers });
    } else {
      result = axios.get('batch-job', { headers: headers });
    }
  }
  return result;
};

export const getBatchJobSetupSuccess = (data) => {
  return {
    type: BATCH_JOB_ALL,
    data,
  };
};

export const getBatchJobDetail = (id, mode, page) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobDetailAPI(id, mode, page)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobDetailSuccess(response.data.response));
        // if (sessionStorage.getItem('application') === 'Transaction Data') {
        //   history.push(
        //     '/transaction-data-batchjob-setup/edit-batchjob-setup/' + id,
        //   );
        // } else if (sessionStorage.getItem('application') === 'Pricing') {
        //   history.push('/pricing-batchjob-setup/edit-batchjob-setup/' + id);
        // } else if (
        //   sessionStorage.getItem('application') === 'Profit Optimization'
        // ) {
        //   history.push('/profitopt-batchjob-setup/edit-batchjob-setup/' + id);
        // } else if (sessionStorage.getItem('application') === 'Integration Studio') {
        //   history.push(
        //     '/integration-batchjob-setup/edit-integration-batchjob-setup/' +
        //     id,
        //   );
        // } else if (
        //   sessionStorage.getItem('application') === 'Customer Chargeback'
        // ) {
        //   history.push('/edit-batchjob-setup-customer-chargeback/' + id);
        // } 
        if (page !== 'New Batch Job') {
          if (mode === 'view') {
            history.push('/batchjob-setup/view-batchjob-setup/' + id);
          } else {
            history.push('/batchjob-setup/edit-batchjob-setup/' + id);
          }
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobDetailAPI = (id, mode, page) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (page === 'New Batch Job') {
    result = axios.get('get-batch-job/' + id, { headers: headers });
  } else {
    result = axios.get('batch-job/' + id, { headers: headers });
  }

  return result;
};

export const getBatchJobDetailSuccess = (data) => {
  return {
    type: BATCH_JOB_DETAIL,
    data,
  };
};
// Pricing Batch Job
export const addPricingBatchJobSetup = (data, edit, id, appType) => {
  return (dispatch) => {
    addPricingBatchJobSetupAPI(data, edit, id)
      .then((response) => {
        if (edit === 'edit') {
          toast.success('Successfully updated.');
          if (appType == 'Salse Data') {
            history.push('/transaction-data-batchjob-setup');
          } else {
            history.push('/pricing-batchjob-setup');
          }
        } else if (edit === 'delete') {
          toast.success('Successfully deleted.');
          dispatch(getPricingBatchJobSetup());
          if (appType == 'Salse Data') {
            history.push('/transaction-data-batchjob-setup');
          } else {
            history.push('/pricing-batchjob-setup');
          }
        } else {
          toast.success('Successfully added.');
          if (appType == 'Salse Data') {
            history.push('/transaction-data-batchjob-setup');
          } else {
            history.push('/pricing-batchjob-setup');
          }
        }
      })
      .catch((error) => { });
  };
};

const addPricingBatchJobSetupAPI = (data, edit, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (edit === 'edit')
    result = axios.put('batch-job/' + id, data, { headers: headers });
  else if (edit === 'delete')
    result = axios.delete('batch-job/' + id, { headers: headers });
  else result = axios.post('batch-job', data, { headers: headers });
  return result;
};

export const getPricingBatchJobSetup = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getPricingBatchJobSetupAPI(type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getPricingBatchJobSetupSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getPricingBatchJobSetupAPI = (type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'Sales Data') {
    result = axios.get('batch-job?app_type=Sales Data', { headers: headers });
  } else {
    result = axios.get('batch-job', { headers: headers });
  }
  return result;
};

export const getPricingBatchJobSetupSuccess = (data) => {
  return {
    type: PRICING_BATCH_JOB_ALL,
    data,
  };
};

export const getPricingBatchJobDetail = (id) => {
  return (dispatch) => {
    getPricingBatchJobDetailAPI(id)
      .then((response) => {
        dispatch(getPricingBatchJobDetailSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};
const getPricingBatchJobDetailAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('batch-job/' + id, { headers: headers });
  return result;
};

export const getPricingBatchJobDetailSuccess = (data) => {
  return {
    type: PRICING_BATCH_JOB_DETAIL,
    data,
  };
};
//  batch job intergration auto params
export const getBatchJobAutoIntegration = (data, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobAutoIntegrationApi(data, id)
      .then((response) => {
        history.push('/integration-batchjob-setup');
        toast.success('Integration Filter Saved Successfully.');
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobAutoIntegrationApi = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('integration-auto-params/' + id, data, {
    headers: headers,
  });
  return result;
};

// territory
export const createTerritory = (data, id, type) => {
  return (dispatch) => {
    createTerritoryAPI(data, id, type)
      .then((response) => {
        toast.success(response.data.response);
        if (type == 'delete') {
          dispatch(getTerritoryListData());
        } else {
          history.push('/terittory');
        }
      })
      .catch((error) => { });
  };
};

const createTerritoryAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete('territory/' + id, { headers: headers });
  } else if (type === 'edit') {
    result = axios.put('territory/' + id, data, { headers: headers });
  } else {
    result = axios.post('territory', data, { headers: headers });
  }
  return result;
};

//exception management
export const getExceptionManagementAll = (id, type, appType) => {
  return (dispatch) => {
    getExceptionManagementAllSuccess([]);
    dispatch(fetchStart());
    getExceptionManagementAllAPI(id, type, appType).then((response) => {
      dispatch(fetchEnd());
      if (id) {
        if (Array.isArray(response.data.response)) {
          dispatch(fetchEnd());
        }
        dispatch(fetchEnd());
        dispatch(getExceptionManagementSingleSuccess(response.data.response));
      } else {
        if (type == 'exception_filter') {
          if (Array.isArray(response.data.response)) {
            dispatch(fetchEnd());
          }
          dispatch(fetchEnd());
          dispatch(
            getExceptionManagementAllSuccess(response.data.response),
          );
          history.push({
            pathname: '/exception-management',
            status: 'from_contract',
          });
        } else {
          if (Array.isArray(response.data.response)) {
            dispatch(fetchEnd());
          }
          dispatch(fetchEnd());
          dispatch(
            getExceptionManagementAllSuccess(response.data.response),
          );
        }
      }
    });
  };
};

const getExceptionManagementAllAPI = (id, type, appType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (id) {
    result = axios.get('incentive-override/' + id, { headers: headers });
  } else if (type === 'list') {
    result = axios.get(
      'incentive-override?page=1&&limit=0' + '&application_type=' + appType,
      {
        headers: headers,
      },
    );
  } else if (type === 'exception_filter') {
    result = axios.get(
      'incentive-override?page=1&&limit=0' +
      '&application_type=' +
      sessionStorage.getItem('application') +
      '&contract_number=' +
      appType,
      {
        headers: headers,
      },
    );
  } else {
    result = axios.get(
      'incentive-override?is_approval=true',
      // &&approval_status.in=new,new_changes',
      { headers: headers },
    );
  }
  return result;
};

export const getExceptionManagementAllSuccess = (data) => {
  return {
    type: EXCEPTION_MANAGEMENT_ALL,
    data,
  };
};

export const getExceptionManagementSingleSuccess = (data) => {
  return {
    type: EXCEPTION_MANAGEMENT_SINGLE,
    data,
  };
};
//
export const getExceptionManagementViewDetails = (id, mode) => {
  return (dispatch) => {
    getExceptionManagementViewDetailsApi(id).then((response) => {
      if (mode != 'edit') history.push('/exception-management/view/' + id);
      dispatch(
        getExceptionManagementViewDetailsApiSuccess(response.data.response),
      );
    });
  };
};
const getExceptionManagementViewDetailsApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('incentive-override/' + id, { headers: headers });
  return result;
};

export const getExceptionManagementViewDetailsApiSuccess = (data) => {
  return {
    type: EXCEPTION_MANAGEMENT_VIEW_DETAIL_SUCCESS,
    data,
  };
};
//

export const addExceptionManagement = (data, type, id) => {
  return (dispatch) => {
    addExceptionManagementAPI(data, type, id)
      .then((response) => {
        if (type == 'delete') {
          toast.success('Successfully deleted.');
          dispatch(
            getExceptionManagementAll(
              null,
              'list',
              sessionStorage.getItem('application'),
            ),
          );
        } else if (type == 'put') {
          toast.success('Successfully updated.');
          history.push('/exception-management');
        } else {
          toast.success('Successfully added.');
          history.push('/exception-management');
        }
      })
      .catch((error) => {
        history.push('/exception-management');
      });
  };
};

const addExceptionManagementAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('incentive-override/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('incentive-override/' + id, { headers: headers });
  } else {
    result = axios.post('incentive-override', data, { headers: headers });
  }
  return result;
};
export const getExceptionTierEvals = (app, data) => {
  return (dispatch) => {
    getExceptionTierEvalsAPI(app, data).then((response) => {
      dispatch(getExceptionTierEvalsSuccess(response.data.response));
    });
  };
};

const getExceptionTierEvalsAPI = (app, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'contracts/exception/tier-evals?application_type=' +
    app +
    '&contract_number=' +
    data,
    { headers: headers },
  );
  return result;
};
export const getExceptionTierEvalsSuccess = (data) => {
  return {
    type: EXCEPTION_MANAGEMENT_TIER_EVALS,
    data,
  };
};

////// Exception upload //////
export const exceptionUpload = (file) => {
  return (dispatch) => {
    dispatch(fetchStart());
    exceptionUploadApi(file)
      .then((response) => {
        if (response.status === 200) {
          dispatch(fetchEnd());
          dispatch(
            getExceptionManagementAll(
              null,
              'list',
              sessionStorage.getItem('application'),
            ),
          );
          if (response && response.data && response.data.response
          ) {
            dispatch(fetchEnd());
            toast.success(response.data.response.response);
          }
          if (response && response.data && response.data.response.warning_message) {
            dispatch(fetchEnd());
            toast.warning(response.data.response.warning_message);
          }
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const exceptionUploadApi = (file) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    '/incentive-override-upload?application_type=Customer Rebate',
    file,
    {
      headers: headers
    },
  );
  return result;
};

//workflow anchors
export const getWorkFlowAnchors = (id) => {
  return (dispatch) => {
    getWorkFlowAnchorsAPI(id).then((response) => {
      dispatch(getWorkFlowAnchorsSuccess(response.data.response));
      sessionStorage.setItem(
        'functionalityDropdown',
        JSON.stringify(response.data.response),
      );
    });
  };
};

const getWorkFlowAnchorsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('workflow-anchors', { headers: headers });
  return result;
};

export const getWorkFlowAnchorsSuccess = (data) => {
  return {
    type: WORKFLOW_ANCHORS,
    data,
  };
};
export const getBatchJobStatus = (app, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobStatusAPI(app, type)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobStatusSuccess(response.data.response));

        history.push({
          pathname: '/batchjob-status/' + type,
          statusType: type,
        });
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobStatusAPI = (app, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  const timeZone = moment.tz.guess();
  var result;

  if (app && type) {
    result = axios.get(
      '/batch-job-status?application_type=' +
      app +
      '&job_filter=' +
      type +
      '&timezone=' +
      timeZone,
      { headers: headers },
    );
  } else if (type)
    result = axios.get(
      '/batch-job-status?job_filter=' + type + '&timezone=' + timeZone,
      { headers: headers },
    );
  else {
    result = axios.get('/batch-job-status', { headers: headers });
  }
  return result;
};

export const getBatchJobStatusSuccess = (data) => {
  return {
    type: BATCH_JOB_STATUS,
    data,
  };
};
//BatchJob blocked unblocked api
export const getBatchJobGroupStatus = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobGroupStatusAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        dispatch(getBatchJobSetup(sessionStorage.getItem('application'), type));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobGroupStatusAPI = (data, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.put('/batch-job-group-status/' + id, data, { headers: headers });
  return result;
};
//BatchJob Reprocess
export const getBatchJobReportPreProcessing = (data, id, type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobReportPreProcessingAPI(data, id, type)
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
        if (type !== 'reprocess') {
          dispatch(getBatchJobSetup(sessionStorage.getItem('application'), type));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobReportPreProcessingAPI = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type !== 'reprocess') {
    result = axios.post('/batch-job/' + id, data, { headers: headers });
  }
  else {
    result = axios.post('/batch-job/' + id + '?reprocessing=true', data, { headers: headers });
  }
  return result;
};
//BatchJob Configuration
export const getBatchJobConfiguration = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobConfigurationAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (data) {
          toast.success(response.data.response);
        }
        dispatch(getBatchJobConfigurationSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobConfigurationAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (data) {
    result = axios.post('/batch-job-configuration', data, { headers: headers });
  }
  else {
    result = axios.get('/batch-job-configuration', { headers: headers });
  }

  return result;
};

export const getBatchJobConfigurationSuccess = (data) => {
  return {
    type: BATCH_JOB_CONFIGURATION,
    data,
  };
};
//BatchJob Report
export const getBatchJobReport = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobReportAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobReportSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobReportAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  // const timeZone = moment.tz.guess();
  var result;
  result = axios.post('/batch-job-reports', data, { headers: headers });
  return result;
};

export const getBatchJobReportSuccess = (data) => {
  return {
    type: BATCH_JOB_REPORT,
    data,
  };
};

export const getBatchJobReportExecutationLog = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobReportExecutationLogAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0) {
          dispatch(getBatchJobReportExecutationLogSuccess(response.data.response));
          history.push('/batchjob-execuion-log-result');
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobReportExecutationLogAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('report-execution-log', data, { headers: headers });
  return result;
};

export const getBatchJobReportExecutationLogSuccess = (data) => {
  return {
    type: BATCH_JOB_REPORT_EXECUTION_LOG,
    data,
  };
};

export const getBatchJobStatusSchedule = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobStatusScheduleAPI(data)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobStatusScheduleSuccess(response.data.response));
        history.push({
          pathname: '/batchjob-schedule',
        });
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobStatusScheduleAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(
    '/create-batch-job-schedules',
    data,
    { headers: headers },
  );
  return result;
};

export const getBatchJobStatusScheduleSuccess = (data) => {
  return {
    type: BATCH_JOB_SCHEDULE,
    data,
  };
};
///// Cancel Batch Job////
export const getCancelBatchJob = (id, action, type, statusType) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCancelBatchJobAPI(id, action, type, statusType)
      .then((response) => {
        dispatch(fetchEnd());
        if (type === 'edit')
          // dispatch(getBatchJobSetup(sessionStorage.getItem('application')));
          dispatch(getBatchJobSetup(sessionStorage.getItem('application'), statusType));
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCancelBatchJobAPI = (id, action, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'edit') {
    return axios.put(`/batch-job-schedules/${id}`, action, { headers });
  } else {
    return axios.put(`/batch-job-schedule-status/${id}`, { action }, { headers });
  }
  return result;
};

export const getBatchJobStatusSecondPage = (type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobStatusSecondPageAPI(type, id)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobStatusSecondPageSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobStatusSecondPageAPI = (type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    '/batch-job-status-history?app_type=' + type + '&integration-id=' + id,
    { headers: headers },
  );
  return result;
};

export const getBatchJobStatusSecondPageSuccess = (data) => {
  return {
    type: BATCH_JOB_STATUS_SECOND_PAGE,
    data,
  };
};
export const getBatchJobStatusSingleData = (type, id, reportID) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getBatchJobStatusSingleDataAPI(type, id, reportID)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getBatchJobStatusSingleDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getBatchJobStatusSingleDataAPI = (type, id, reportID) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (reportID) {
    result = axios.get(
      '/batch-job-status/' +
      id +
      '?app_type=' +
      type +
      '&report_id=' +
      reportID,
      { headers: headers },
    );
  } else {
    result = axios.get('/batch-job-status/' + id + '?app_type=' + type, {
      headers: headers,
    });
  }
  return result;
};

export const getBatchJobStatusSingleDataSuccess = (data) => {
  return {
    type: BATCH_JOB_STATUS_SINGLE_DATA,
    data,
  };
};

//get list customer master
export const getGeneralUOM = () => {
  return (dispatch) => {
    getGeneralUOMAPI()
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.response &&
          response.data.response.unique_uom
        )
          dispatch(getGeneralUOMSuccess(response.data.response.unique_uom));
      })
      .catch((error) => { });
  };
};

const getGeneralUOMAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('general-unique-uom', { headers: headers });

  return result;
};

export const getGeneralUOMSuccess = (data) => {
  return {
    type: GENERAL_UOM,
    data,
  };
};

//currency conversion

export const getCurrencyConversionData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCurrencyConversionDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getCurrencyConversionDataSuccess(response.data));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCurrencyConversionDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.get('currency-rates', { headers: headers });
  return result;
};

export const getCurrencyConversionDataSuccess = (data) => {
  return {
    type: CONVERSION_SUCCESS,
    data,
  };
};

// integration mapping

export const getIntegrationMappingData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationMappingDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(getIntegrationMappingDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        ////toast.error(error.response.data.messgae);
      });
  };
};

const getIntegrationMappingDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'integrations-mapped?application_type=' +
    sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};

export const getIntegrationMappingDataSuccess = (data) => {
  return {
    type: INTEGRATION_MAPPING_SUCCESS,
    data,
  };
};

export const getIntegrationMappingDataById = (id) => {
  return (dispatch) => {
    getIntegrationMappingDataByIdApi(id)
      .then((response) => {
        dispatch(getIntegrationMappingDataByIdSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(ServerError);
      });
  };
};

const getIntegrationMappingDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'integration-mappings/' +
    id +
    '?application_type=' +
    sessionStorage.getItem('application'),
    { headers: headers },
  );
  return result;
};

export const getIntegrationMappingDataByIdSuccess = (data) => {
  return {
    type: INTEGRATION_MAPPING_BY_ID,
    data,
  };
};

export const createIntegrationMapping = (data, id, type) => {
  return (dispatch) => {
    createIntegrationMappingApi(data, id, type)
      .then((response) => {
        if (type == 'delete') {
          toast.success(response.data.response);
          dispatch(getIntegrationMappingData());
        } else {
          toast.success(response.data.message);
          if (response.data.savedRows) {
            if (type == 'edit')
              dispatch(
                getIntegrationMappingDataById(
                  response.data.savedRows['integration_id'],
                ),
              );
            else {
              // console.log('test2');
              dispatch(
                getIntegrationMappingDataById(
                  response.data.savedRows[0].integration_id,
                ),
              );
            }

            //dispatch(createIntegrationMappingApiSuccess(response.data.savedRows))
          }
        }
      })
      .catch((error) => {
        //toast.error(error.response.data.error.complete_error_message);
      });
  };
};

const createIntegrationMappingApi = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type == 'edit')
    result = axios.post(
      'integration-mapping?application_type=' +
      sessionStorage.getItem('application') +
      '&update_id=' +
      id,
      data,
      { headers: headers },
    );
  else if (type == 'delete')
    result = axios.delete(
      'integration-mapping/' +
      id +
      '?application_type=' +
      sessionStorage.getItem('application'),
      { headers: headers },
    );
  //for delete all mappings
  else
    result = axios.post(
      'integration-mapping?application_type=' +
      sessionStorage.getItem('application'),
      data,
      { headers: headers },
    );
  return result;
};
export const createIntegrationMappingApiSuccess = (data) => {
  return {
    type: MAPPING_CREATE_SUCCESS,
    data,
  };
};
export const getIntegrationConfigurationData = () => {
  return (dispatch) => {
    dispatch(fetchStart());

    getIntegrationConfigurationDataApi()
      .then((response) => {
        dispatch(fetchEnd());

        if (response.data?.response?.length > 0) {
          dispatch(
            getIntegrationConfigurationDataSuccess(response.data.response),
          );
        } else {
          dispatch(getIntegrationConfigurationDataSuccess([]));
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
        // console.error('Error fetching integration configuration:', error);
        dispatch(getIntegrationConfigurationDataSuccess([]));
      });
  };
};

const getIntegrationConfigurationDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  return axios.get('/integration-configuration', { headers });
};

export const getIntegrationConfigurationDataSuccess = (data) => {
  return {
    type: INTEGRATION_CONFIGURATION_SUCCESS,
    data,
  };
};
//Inegration Qualifiers APIs

export const getIntegrationQualifiersData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationQualifiersDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0)
          dispatch(getIntegrationQualifiersDataSuccess(response.data.response));
        else dispatch(getIntegrationQualifiersDataSuccess([]));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getIntegrationQualifiersDataSuccess([]));
      });
  };
};

const getIntegrationQualifiersDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-qualifiers', { headers: headers });
  return result;
};

export const getIntegrationQualifiersDataSuccess = (data) => {
  return {
    type: INTEGRATION_QUALIFIERS_SUCCESS,
    data,
  };
};

export const getIntegrationQualifiersFunctionalityData = (appType) => {
  return (dispatch) => {
    getIntegrationQualifiersFunctionalityDataApi(appType)
      .then((response) => {
        dispatch(
          getIntegrationQualifiersFunctionalityDataSuccess(
            response.data.response,
          ),
        );
      })
      .catch((error) => { });
  };
};

const getIntegrationQualifiersFunctionalityDataApi = (appType) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'approval-workflow/application-functionality?application_type=' + appType,
    { headers: headers },
  );
  return result;
};

export const getIntegrationQualifiersFunctionalityDataSuccess = (data) => {
  return {
    type: INTEGRATION_QUALIFIERS_FUNCTIONALITY_SUCCESS,
    data,
  };
};
export const getIntegrationQualifiersTableNameData = (tableName) => {
  return (dispatch) => {
    getIntegrationQualifiersTableNameDataApi(tableName)
      .then((response) => {
        // dispatch(getIntegrationQualifiersTableNameDataSuccess(response.data.response));
        dispatch(
          getIntegrationQualifiersTableNameDataSuccess(response.data.fields),
        );
      })
      .catch((error) => { });
  };
};

const getIntegrationQualifiersTableNameDataApi = (tableName) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'table-field-names?table_name=' + tableName + '&show_data_type=false',
    { headers: headers },
  );
  return result;
};

export const getIntegrationQualifiersTableNameDataSuccess = (data) => {
  return {
    type: INTEGRATION_QUALIFIERS_TABLE_NAME_SUCCESS,
    data,
  };
};

export const addIntegrationQualifiersData = (data, id, type) => {
  return (dispatch) => {
    addIntegrationQualifiersDataApi(data, id, type)
      .then((response) => {
        if (type === 'delete') {
          toast.success(response.data.response);
          dispatch(getIntegrationQualifiersData());
        } else {
          history.push('/integration-qualifiers');
          toast.success(response.data.response);
        }
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const addIntegrationQualifiersDataApi = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete('integration-qualifiers/' + id, { headers: headers });
  } else if (type === 'edit') {
    result = axios.put('integration-qualifiers/' + id, data, {
      headers: headers,
    });
  } else {
    result = axios.post('integration-qualifiers', data, { headers: headers });
  }
  return result;
};

export const getIntegrationQualifiersDataById = (id) => {
  return (dispatch) => {
    getIntegrationQualifiersDataByIdApi(id)
      .then((response) => {
        dispatch(
          getIntegrationQualifiersDataByIdSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error(ServerError);
      });
  };
};

const getIntegrationQualifiersDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-qualifiers/' + id, { headers: headers });
  return result;
};

export const getIntegrationQualifiersDataByIdSuccess = (data) => {
  return {
    type: INTEGRATION_QUALIFIERS_DATA_BY_ID,
    data,
  };
};

//Integration List Apis

export const getIntegrationListData = (appType, Func) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getIntegrationListDataApi(appType, Func)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response && response.data.response.records.length > 0)
          dispatch(getIntegrationListDataSuccess(response.data.response));
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getIntegrationListDataApi = (appType, Func) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (appType && Func) {
    result = axios.get(
      'integration-filters?application_type=' +
      appType +
      '&functionality=' +
      Func,
      { headers: headers },
    );
  } else {
    result = axios.get('integration-filters', { headers: headers });
  }
  return result;
};

export const getIntegrationListDataSuccess = (data) => {
  return {
    type: INTEGRATION_LIST_DATA_SUCCESS,
    data,
  };
};

export const addIntegrationListData = (data, id, type) => {
  return (dispatch) => {
    addIntegrationListDataApi(data, id, type)
      .then((response) => {
        if (type === 'delete') {
          toast.success(response.data.response);
          dispatch(getIntegrationListData());
        } else {
          history.push('/integration-list');
          toast.success(response.data.response);
        }
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const addIntegrationListDataApi = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete('integration-filter/' + id, { headers: headers });
  } else if (type === 'edit') {
    result = axios.put('integration-filter/' + id, data, { headers: headers });
  } else {
    result = axios.post('integration-filter', data, { headers: headers });
  }
  return result;
};

export const getIntegrationListDataById = (id) => {
  return (dispatch) => {
    getIntegrationListDataByIdApi(id)
      .then((response) => {
        dispatch(getIntegrationListDataByIdSuccess(response.data.response));
      })
      .catch((error) => {
        //toast.error(ServerError);
      });
  };
};

const getIntegrationListDataByIdApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-filter/' + id, { headers: headers });
  return result;
};

export const getIntegrationListDataByIdSuccess = (data) => {
  return {
    type: INTEGRATION_LIST_DATA_BY_ID,
    data,
  };
};

// New Inegration Mapping APIs

export const getNewIntegrationMappingData = (direction, dataset) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getNewIntegrationMappingDataApi(direction, dataset)
      .then((response) => {
        dispatch(fetchEnd());
        if (response.data.response.length > 0)
          dispatch(getNewIntegrationMappingDataSuccess(response.data.response));
        else dispatch(getNewIntegrationMappingDataSuccess([]));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        dispatch(getNewIntegrationMappingDataSuccess([]));
      });
  };
};

const getNewIntegrationMappingDataApi = (direction, dataset) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  let url = direction
    ? `integration-new-mappings?service=${direction}`
    : 'integration-new-mappings';
  if (dataset) {
    url += `&dataset_name=${dataset}`;
  }
  result = axios.get(url, {
    headers: headers,
  });
  // // Check if 'inbound' is part of the current URL
  // const isInbound = window.location.href.includes('inbound');

  // // Build query string if needed
  // const url = isInbound
  //   ? 'integration-new-mappings?service=inbound'
  //   : 'integration-new-mappings';

  // result = axios.get(url, { headers });

  // result = axios.get('integration-new-mappings', { headers: headers });
  return result;
};

export const getNewIntegrationMappingDataSuccess = (data) => {
  return {
    type: NEW_INTEGRATION_MAPPING_SUCCESS,
    data,
  };
};

export const addNewIntegrationMappingData = (data, id, type, page) => {
  return (dispatch) => {
    addNewIntegrationMappingDataApi(data, id, type, page)
      .then((response) => {
        const currentPath = window.location.pathname;
        let pathType = '';
        if (currentPath.includes('inbound')) {
          pathType = 'inbound';
        } else if (currentPath.includes('outbound')) {
          pathType = 'outbound';
        }
        if (type === 'delete' || type === 'clone') {
          toast.success(response.data.response);
          dispatch(getNewIntegrationMappingData(pathType));
        } else {
          if (page === 'new') {
            history.push('/integration-mapping-inbound');
            toast.success(response.data.response);
          }
          else {
            let redirectPath = '';

            if (pathType === 'inbound') {
              redirectPath = '/inbound-mapping-new';
            } else if (pathType === 'outbound') {
              redirectPath = '/outbound-mapping-new';
            }
            history.push(redirectPath);
            toast.success(response.data.response);
          }
        }
      })
      .catch((error) => {
        //toast.error(error.response.data.error.message);
      });
  };
};

const addNewIntegrationMappingDataApi = (data, id, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'delete') {
    result = axios.delete(
      'integration-new-mappings/' + id + '?table_name=integration_dataset',
      { headers: headers },
    );
  } else if (type === 'edit') {
    result = axios.put('integration-new-mappings/' + id, data, {
      headers: headers,
    });
  } else if (type === 'clone') {
    result = axios.post('integration-new-mappings/' + id + '?dataset=' + data, {
      headers: headers,
    });
  } else {
    result = axios.post('integration-new-mappings', data, { headers: headers });
  }
  return result;
};

export const getNewIntegrationMappingDataById = (id, name) => {
  return (dispatch) => {
    getNewIntegrationMappingDataByIdApi(id, name)
      .then((response) => {
        dispatch(
          getNewIntegrationMappingDataByIdSuccess(response.data.response),
        );
      })
      .catch((error) => {
        //toast.error(ServerError);
      });
  };
};

const getNewIntegrationMappingDataByIdApi = (id, name) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (name) {
    result = axios.get('integration-new-mappings/' + id +
      '?dataset_name=' + name, { headers: headers });
  }
  else {
    result = axios.get('integration-new-mappings/' + id, { headers: headers });
  }
  return result;
};

export const getNewIntegrationMappingDataByIdSuccess = (data) => {
  return {
    type: NEW_INTEGRATION_MAPPINGS_DATA_BY_ID,
    data,
  };
};

//mapping fields
export const getIntegrationMappingFields = (actvity) => {
  return (dispatch) => {
    getIntegrationMappingFieldsApi(actvity)
      .then((response) => {
        dispatch(getIntegrationMappingFieldsSuccess(response.data.response));
      })
      .catch((error) => {
        ////toast.error(error.response.data.messgae);
      });
  };
};

const getIntegrationMappingFieldsApi = (actvity) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-map-fields?activity=' + actvity, {
    headers: headers,
  });
  return result;
};

export const getIntegrationMappingFieldsSuccess = (data) => {
  return {
    type: INTEGRATION_MAPPING_FIELDS,
    data,
  };
};

export const deleteIntegrationMapping = (id, typeId) => {
  return (dispatch) => {
    deleteIntegrationMappingApi(id)
      .then((response) => {
        toast.success(response.data.response);
        dispatch(getIntegrationMappingDataById(typeId));
      })
      .catch((error) => {
        //toast.error(ServerError);
      });
  };
};

const deleteIntegrationMappingApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result = axios.delete('integration-mapping-ind/' + id, {
    headers: headers,
  });

  return result;
};
export const uploadIntegrationFile = (file, version) => {
  return (dispatch) => {
    dispatch(fetchStart());
    uploadIntegrationFileApi(file, version)
      .then((response) => {
        dispatch(fetchEnd());
        dispatch(uploadIntegrationResponse(response.data));
        dispatch(getIntegrationMappingDataById(version));
      })
      .catch((error) => {
        dispatch(fetchEnd());
        //toast.error(error.response.data);
      });
  };
};

const uploadIntegrationFileApi = async (file, version) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
    'Content-Type': 'multipart/form-data;',
  };
  var result;
  if (version === 'v2') {
    result = await axios.post('integration-mapping-upload/v2', file, {
      headers: headers,
    });
  } else {
    result = await axios.post('integration-mapping-upload', file, {
      headers: headers,
    });
  }
  return result;
};
export const uploadIntegrationResponse = (data) => {
  return {
    type: UPLOAD_INTEGRATION_FILE,
    data,
  };
};

//inttegrationFieldvalues
export const getIntegrationFieldValues = (option, type) => {
  return (dispatch) => {
    getIntegrationFieldValuesApi(option)
      .then((response) => {
        if (type == 'activityList')
          dispatch(getActivityListSuccess(response.data.response));
        else if (option == 'loadFrequencyValues') {
          dispatch(getLoadFrequencyListSuccess(response.data.response));
        } else dispatch(getDataSourceListSuccess(response.data.response));
      })
      .catch((error) => {
        ////toast.error(error.response.data.messgae);
      });
  };
};

const getIntegrationFieldValuesApi = (option) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('integration-field-value?option=' + option, {
    headers: headers,
  });
  return result;
};

export const getActivityListSuccess = (data) => {
  return {
    type: INTEGRATION_ACTIVITY,
    data,
  };
};
export const getLoadFrequencyListSuccess = (data) => {
  return {
    type: INTEGRATION_LOAD_FREQUENCY,
    data,
  };
};
export const getDataSourceListSuccess = (data) => {
  return {
    type: INTEGRATION_DATA_SOURCE,
    data,
  };
};

// Integration Studio Batch Job

export const addIntegrationBatchJobSetup = (data, edit, id) => {
  return (dispatch) => {
    addIntegrationBatchJobSetupAPI(data, edit, id)
      .then((response) => {
        history.push('/integration-batchjob-setup');
        if (edit === 'edit') toast.success(response.data.response);
        else if (edit === 'delete') {
          toast.success(response.data.response);
          dispatch(getBatchJobSetup());
        } else {
          toast.success(response.data.response);
        }
      })
      .catch((error) => { });
  };
};

const addIntegrationBatchJobSetupAPI = (data, edit, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (edit === 'edit')
    result = axios.put('batch-job/' + id, data, { headers: headers });
  else if (edit === 'delete')
    result = axios.delete('batch-job/' + id, data, { headers: headers });
  else result = axios.post('batch-job', data, { headers: headers });
  return result;
};

export const getIntegrationBatchJobSetup = () => {
  return (dispatch) => {
    getIntegrationBatchJobSetupAPI()
      .then((response) => {
        dispatch(getIntegrationBatchJobSetupSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getIntegrationBatchJobSetupAPI = (data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('batch-job?app_type=Integration Studio', {
    headers: headers,
  });
  return result;
};

export const getIntegrationBatchJobSetupSuccess = (data) => {
  return {
    type: BATCH_INTEGRATION_JOB_ALL,
    data,
  };
};

export const getIntegrationBatchJobStatus = (id) => {
  return (dispatch) => {
    getIntegrationBatchJobStatusAPI(id)
      .then((response) => {
        dispatch(getIntegrationBatchJobStatusSuccess(response.data.response));
      })
      .catch((error) => { });
  };
};

const getIntegrationBatchJobStatusAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('/batch-job-status?app_type=Integration Studio', {
    headers: headers,
  });
  return result;
};

export const getIntegrationBatchJobStatusSuccess = (data) => {
  return {
    type: BATCH_INTEGRATION_JOB_STATUS,
    data,
  };
};
// membership update
export const updateMembershipData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    updateMembershipDataApi()
      .then((response) => {
        dispatch(fetchEnd());
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};
const updateMembershipDataApi = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post('membership-update', { headers: headers });
  return result;
};
export const addWorkFlowAssignments = (data, type, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addWorkFlowAssignmentsAPI(data, type, id)
      .then((response) => {
        dispatch(fetchEnd());

        if (type === 'delete') {
          dispatch(getWorkFlowAssignments(1, 0));
          toast.success(response.data.response);
        } else {
          history.push('/workflow-assignment');
          toast.success(response.data.response);
        }
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addWorkFlowAssignmentsAPI = (data, type, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type === 'put') {
    result = axios.put('workflow-assignment/' + id, data, { headers: headers });
  } else if (type === 'delete') {
    result = axios.delete('workflow-assignment/' + id, data, {
      headers: headers,
    });
  } else {
    result = axios.post('workflow-assignment', data, { headers: headers });
  }
  return result;
};
export const getWorkFlowAssignments = (pagination, limit) => {
  return (dispatch) => {
    getWorkFlowAssignmentsAPI(pagination, limit).then((response) => {
      dispatch(getWorkFlowAssignmentsSuccess(response.data.response));
    });
  };
};

const getWorkFlowAssignmentsAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'workflow-assignment?page=' + pagination + '&limit=' + limit,
    {
      headers: headers,
    },
  );
  return result;
};

export const getWorkFlowAssignmentsSuccess = (data) => {
  return {
    type: WORK_FLOW_ASSIGNMENTS_SUCCESS,
    data,
  };
};
export const getWorkFlowAssignmentsDetails = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getWorkFlowAssignmentsDetailsAPI(id).then((response) => {
      dispatch(fetchEnd());
      dispatch(getWorkFlowAssignmentsDetailsSuccess(response.data.response));
    });
  };
};

const getWorkFlowAssignmentsDetailsAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get('workflow-assignment/' + id, { headers: headers });
  return result;
};

export const getWorkFlowAssignmentsDetailsSuccess = (data) => {
  return {
    type: WORK_FLOW_ASSIGNMENTS_DETAIL_SUCCESS,
    data,
  };
};
// global default designer
export const getDefaultDesignerConfig = (pagination, limit) => {
  return (dispatch) => {
    dispatch(fetchStart());
    getDefaultDesignerConfigAPI(pagination, limit).then((response) => {
      dispatch(fetchEnd());
      dispatch(getDefaultDesignerConfigSuccess(response.data.response));
    });
  };
};

const getDefaultDesignerConfigAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    'config-application-functionality',
    // + pagination + '&limit=' + limit
    {
      headers: headers,
    },
  );
  return result;
};

export const getDefaultDesignerConfigSuccess = (data) => {
  return {
    type: DEFAULT_DESIGNER_CONFIG_SUCCESS,
    data,
  };
};
export const searchSupplierNumber = (data, type) => {
  return (dispatch) => {
    searchSupplierNumberAPI(data, type)
      .then((response) => {
        dispatch(searchSupplierNumberSuccess(response.data.response?.records));
      })
      .catch(() => { });
  };
};

const searchSupplierNumberAPI = (data, type) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.post(`master-data-search?page=1&&limit=0&&table_name=${type ? type : 'supplier'}_master`, data, { headers });
  return result;
};

export const searchSupplierNumberSuccess = (data) => {
  return {
    type: SEARCH_SUPPLIER_NUMBER_SUCCESS,
    data,
  };
};
//download
// export const getIntegrationDownload = (data, activity) => {
//   return (dispatch) => {
//     dispatch(fetchStart());
//     getIntegrationDownloadApi(data)
//       .then((response) => {
//         dispatch(fetchEnd());
//         if (response.data.response === 'No Record Found') {
//           toast.error(response.data.response);
//         } else {
//           if (response.headers['content-type'] === 'application/zip') {
//             toast.info('Downloading has been started in background. File will be downloaded automatically once ready.');

//             const url = window.URL.createObjectURL(
//               new Blob([response.data]),
//             );
//             const link = document.createElement('a');
//             link.href = url;
//             let date = Date.now();
//             link.setAttribute('download', activity + '.zip');
//             document.body.appendChild(link);
//             link.click();

//           } else {
//             toast.error('No Record Found');
//           }
//         }
//       })
//       .catch((error) => {
//         toast.error(error.response.data.complete_error_message);
//         dispatch(fetchEnd());
//       });
//   };
// };
export const getIntegrationDownload = (data, activity) => {
  return (dispatch) => {
    dispatch(fetchStart());

    getIntegrationDownloadApi(data)
      .then(async (response) => {
        dispatch(fetchEnd());

        const contentType = response.headers['content-type'];

        if (contentType.includes('application/zip')) {
          toast.info('Downloading has been started in background. File will be downloaded automatically once ready.');

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${activity}.zip`);
          document.body.appendChild(link);
          link.click();
        } else {
          // Try parsing blob as JSON
          try {
            const text = await response.data.text();
            const json = JSON.parse(text);
            toast.error(json.complete_error_message || json.response || 'No Record Found');
          } catch {
            toast.error('An unknown error occurred while downloading.');
          }
        }
      })
      .catch(async (error) => {
        dispatch(fetchEnd());

        // If error also comes as blob
        if (error?.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const json = JSON.parse(text);
            toast.error(json.complete_error_message || json.response || 'Download failed.');
          } catch {
            toast.error('An unknown error occurred.');
          }
        } else {
          toast.error(error?.response?.data?.complete_error_message || 'Download failed.');
        }
      });
  };
};

const getIntegrationDownloadApi = (data) => {
  for (var propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };

  var result = axios.post(
    'integration/simulator',
    data,
    { headers: headers, responseType: 'blob' },
  );

  return result;
};